import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { State, City } from "country-state-city";

import { Eye, Send, CreditCard, Users,Feather,Leaf } from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Badge } from "./ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import {
  Camera,
  Edit2,
  Save,
  X,
  Star,
  Heart,
  MessageCircle,
  Shield,
  Menu,
  User,
  Crown,
  Plus,
} from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import {
  BASE_URL,
  deleteWithTokenAPI,
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../util/Api";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import { setUserId } from "../redux/userSlice";
import { setUsername, setZodiacId } from "../redux/userSlice";
import { setProfessionalId, setPreferenceId } from "../redux/userSlice";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";
import "../styles/ProfileDashboard.css";
import { Item } from "@radix-ui/react-select";
import { Header } from "./Header";
import InterestSend from "./InterestSend";
import InterestReceive from "./IntersetReceive";
import Profileviews from "./Profileviews";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import {
  Scissors,
  Upload,
  Move,
  ZoomIn,
  CheckCircle,
  Info,
  Crop,
  Square,
} from "lucide-react";
// Import React Select
import ReactSelect from "react-select";
import Paymenthistory from "./Paymenthistory";

export function ProfileDashboard({ onNavigate }) {
  const [viewcount, setViewCount] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
  // const [viewerProfiles, setviewerProfiles] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const handleLogout = () => {
    setShowLogoutDialog(true);
  };
  const navigate = useNavigate();
  const [profileData, setprofileData] = useState("");
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user);
  console.log(data, "data");
  const { professionalId, preferenceId, zodiacid } = useSelector(
    (state) => state.user
  );
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;

  const { t, i18n } = useTranslation();
  console.log(id, "___ID----");
  const [subpack, setSubsPack] = useState("");
  // Add this state with your other useState declarations
  const [errors, setErrors] = useState({});
  const [completion, setCompletion] = useState(0);
  console.log(completion, "PROFILE COMPLETION");
  const [header, setHeader] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  // Religion list array
  const religionList = [
    "Hindu",
    "Christian",
    "Muslim",
    "Buddhist",
    "Jain",
    "Sikh",
    "No Religion Barrier",
  ];
  // Religion list array
  const religionLists = [
    "Hindu",
    "Christian",
    "Muslim",
    "Buddhist",
    "Jain",
    "Sikh",
    "Prefer not to say",
  ];

  // religionOptions creation
  const religionOptions = religionList.map((religion) => ({
    value: religion,
    label: t(religion), // Translated label for display
  }));
  // religionOptions creation
  const religionOption = religionLists.map((religion) => ({
    value: religion,
    label: t(religion), // Translated label for display
  }));
  // Education list array
  const educationList = [
  t("No formal education"),
  t("Primary school"),
  t("Secondary school"),
  t("Higher secondary"),
  t("Diploma"),
  t("Vocational training"),
  t("Bachelor's degree"),
  t("Master's degree"),
  t("M.Phil"),
  t("Doctorate / Ph.D"),
  t("Professional degree"),
  t("Medical degree"),
  t("Engineering degree"),
  t("Other")
  ];

  // Convert education list to React Select options
  const educationOptions = educationList.map((education) => ({
    value: education,
    label: t(education),
  }));

  async function handleDeleteAccount() {
    try {
      const response = await deleteWithTokenAPI(
        token,
        `/profile/delete/${id}` // 👈 your user ID
      );

      if (response?.statusCode === 200) {
        setShowLogoutDialog(false);
        dispatch(clearUserState(null));
        localStorage.removeItem("UserId");
        navigate("/");
        toast.success(t("Account deleted successfully!"));
      } else {
       toast.error(response?.message || t("Failed to delete account"));
      }
    } catch (err) {
      console.log("Failed to delete account", err);
       toast.error(t("Something went wrong!"));
    }

    setOpenConfirm(false);
  }

  const [sentInterestIds, setSentInterestIds] = useState([]);
  //-----------------claculate age function-----------
  const calculateAge = (dob) => {
    if (!dob) return "";

    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };
  //-------------------Fetch ProfileName default for nav Name-------------------
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${id}`
        );
        setprofileData(response?.data?.profile?.name);

        setSubsPack(response?.data?.subscription?.plan_name);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    if (id && token) {
      fetchProfile();
    }
  }, [id, token]); // ✅ Proper dependencies

  const [profile, setProfile] = useState({
    name: "",
    dob: "",
    age: "",
    gender: "",
    mobile: "",
    maritalStatus: "",
    religion: "",
    caste: "",
    district: "",
    state: "",
    status: "",
    profileImage: "",
    child_count: "",
  });
  console.log(profile, "PROFILE DETAILS FETCH");

  const [professional, setProfessional] = useState({
    profession: "",
    education: "",
    income: "",
    height: "",
    weight: "",
    diet: "",
    gallery: [],
    documentId: [],
    instagram: "",
    subCaste: "",
    motherTongue: "",
    rasi: "",
    natchathiram: "",
    gothram: "",
    laknam: "",
    dosham: "",
    kujaDosham: "",
    aboutMe: "",
  });

  const [preference, setPreference] = useState({
    min_age: "",
    max_age: "",
    min: "",
    max: "",
    marital_status: "",
    mother_tongue: "",
    religion: [],
    caste: [],
    sub_caste: "",
    diet: "",
    education_level: "",
    district: [],
    gender_preference: "",
    state: "",
    family_status: "",
    family_type: "",
    family_values: "",
    about_partner: "",
  });

  const stats = {
    profileViews: 156,
    interests: 23,
    matches: 8,
    messages: 12,
  };

  const [rasibox, setRasiBox] = useState({
    house1: [],
    house2: [],
    house3: [],
    house4: [],
    house5: [],
    house6: [],
    house7: [],
    house8: [],
    house9: [],
    house10: [],
    house11: [],
    house12: [],
  });

  const [navamsabox, setNavamsaBox] = useState({
    house1: [],
    house2: [],
    house3: [],
    house4: [],
    house5: [],
    house6: [],
    house7: [],
    house8: [],
    house9: [],
    house10: [],
    house11: [],
    house12: [],
  });
  console.log(rasibox, "rasibox");
  console.log(navamsabox, "navamsabox");
  const recentActivity = [
    { type: "view", name: "Rajesh Kumar", time: "2 hours ago" },
    { type: "interest", name: "Anita Reddy", time: "5 hours ago" },
    { type: "message", name: "Suresh Menon", time: "1 day ago" },
    { type: "match", name: "Kavitha Nair", time: "2 days ago" },
  ];

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [cropImage, setCropImage] = useState(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showMultiPreview, setShowMultiPreview] = useState(false);
  const [filesToCrop, setFilesToCrop] = useState([]);
  const [currentCropIndex, setCurrentCropIndex] = useState(0);
  const GALLERY_DEFAULT_ASPECT = 4 / 3;
  const [galleryCropAspect, setGalleryCropAspect] = useState(
    GALLERY_DEFAULT_ASPECT
  );

  const [profileCropImage, setProfileCropImage] = useState(null);
  const [profileCrop, setProfileCrop] = useState();
  const [profileCompletedCrop, setProfileCompletedCrop] = useState();
  const [profileCropAspect, setProfileCropAspect] = useState(1);
  const profileImgRef = useRef(null);
  const imgRef = useRef(null);

  // Returns a crop that selects the entire image (used for the "Full Image" mode)
  const getFullImageCrop = () => ({
    unit: "%",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });

  useEffect(() => {
    const indianStates = State.getStatesOfCountry("IN");
    setStates(indianStates);
  }, []);

  const fetchDistricts = (stateName) => {
    const selectedState = states.find((s) => s.name === stateName);

    if (!selectedState) {
      setDistricts([]);
      return;
    }

    const cities = City.getCitiesOfState("IN", selectedState.isoCode);
    setDistricts(cities.map((c) => c.name));
  };

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }
  //   useEffect(() => {
  //     if (profileCropImage || showMultiPreview) {
  //       document.body.style.overflow = "hidden";
  //       document.body.style.backgroundColor = "rgba(0,0,0,0.5)"; // subtle dim
  //     } else {
  //       document.body.style.overflow = "unset";
  //       document.body.style.backgroundColor = "";
  //     }

  //     return () => {
  //       document.body.style.overflow = "unset";
  //       document.body.style.backgroundColor = "";
  //     };
  //   }, [profileCropImage,cropImage, showMultiPreview]);

  //    useEffect(() => {
  //   if (cropImage || showMultiPreview) {
  //     document.body.classList.add('dialog-open');
  //   } else {
  //     document.body.classList.remove('dialog-open');
  //   }

  //   return () => {
  //     document.body.classList.remove('dialog-open');
  //   };
  // }, [cropImage,showMultiPreview]);
  //UseEffect to blur and disable page when crop is open
  useEffect(() => {
    const hasAnyDialogOpen = profileCropImage || cropImage || showMultiPreview;

    if (hasAnyDialogOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.backgroundColor = "rgba(0,0,0,0.8)";
      document.body.classList.add("dialog-open");
      console.log("Dialog opened - background disabled"); // Debug
    } else {
      document.body.style.overflow = "unset";
      document.body.style.backgroundColor = "";
      document.body.classList.remove("dialog-open");
      console.log("Dialog closed - background enabled"); // Debug
    }

    return () => {
      // Cleanup on unmount
      document.body.style.overflow = "unset";
      document.body.style.backgroundColor = "";
      document.body.classList.remove("dialog-open");
    };
  }, [profileCropImage, cropImage, showMultiPreview]);

  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          resolve(blob);
        },
        "image/jpeg",
        0.9
      );
    });
  };
  //crop Profile Image
  const handleProfileCropAndUpload = async () => {
    if (!profileCompletedCrop || !profileImgRef.current) return;

    try {
      const croppedImageBlob = await getCroppedImg(
        profileImgRef.current,
        profileCompletedCrop
      );

      const fileToUpload = new File(
        [croppedImageBlob],
        `profile-image-${Date.now()}.jpg`,
        {
          type: "image/jpeg",
        }
      );

      const formData = new FormData();
      formData.append("file", fileToUpload);

      const response = await postWithTokenAPI(
        token,
        `/document/upload?type=profile&userId=${id}`,
        formData
      );

      if (response?.statusCode == 200) {
        console.log("✅ Profile upload response:", response.data[0]);
        toast.success(`${t("Profile Photo uploaded Successfully")}`);
        const uploadedUrl = response?.data[0]?.url;
        const payload = {
          profileImage: uploadedUrl,
        };

        const setresponse = await putWithTokenAPI(
          token,
          `/basic-profile/update?user_id=${id}`,
          payload
        );

        if (setresponse?.statusCode === 200) {
          // Update local profile state with new image
          setProfile((prev) => ({
            ...prev,
            "profile.profileImage": uploadedUrl,
          }));
        }
      }
    } catch (error) {
      console.error("Error uploading profile photo:", error);
      toast.error(`${t("Failed to update profile photo")}`);
    } finally {
      // Reset crop states
      setProfileCropImage(null);
      setProfileCrop(undefined);
      setProfileCompletedCrop(undefined);
      setProfileCropAspect(1);
    }
  };
  //crop Gallery Image
  const handleCropAndUpload = async (file = null) => {
    if (!completedCrop || !imgRef.current) return;

    try {
      const croppedImageBlob = await getCroppedImg(
        imgRef.current,
        completedCrop
      );

      // Use the provided file or current crop image
      const fileToUpload =
        file ||
        new File([croppedImageBlob], `cropped-image-${Date.now()}.jpg`, {
          type: "image/jpeg",
        });

      const formData = new FormData();
      formData.append("file", fileToUpload);

      const response = await postWithTokenAPI(
        token,
        `/document/upload?type=gallery&userId=${id}`,
        formData
      );

      if (response?.statusCode === 200) {
        console.log("✅ Upload response:", response.data);
        toast.success(`${t(" Gallery Photo uploaded. Pending admin approval")}`);

        const uploadedUrl = response?.data[0]?.url;
        const uploadedD_id = response?.data[0]?.documentId;
        console.log(uploadedUrl, uploadedD_id, "URL,ID");
        // Add to local gallery state
        const newGalleryItem = {
          url: uploadedUrl,
          documentId: uploadedD_id,
        };
        const updatedGallery = [...galleryUrl, newGalleryItem];
        console.log(updatedGallery, "UPDATEDGALLERY");
        setGalleryUrl(updatedGallery);

        // Prepare payload with separate arrays for URLs and documentIds
        const payload = {
          gallery: updatedGallery.map((item) => item.url), // Array of URLs
          documentId: updatedGallery.map((item) => item.documentId), // Array of documentIds
        };

        console.log("📤 Sending payload:", payload);

        // Send updated gallery to professional profile API
        const setresponse = await putWithTokenAPI(
          token,
          `/professional-profile/update?user_id=${id}`,
          payload
        );

        if (setresponse?.statusCode === 200) {
          console.log("✅ Professional profile gallery updated successfully");
        } else {
          console.error("❌ Gallery update failed:", setresponse);
        }
      }
    } catch (error) {
      toast.error(t("Failed to upload image"));
    }
  };

  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
    else return str.toUpperCase();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    // If it's already in dd-mm-yyyy format, return as is
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      return dateString;
    }

    // If it's in yyyy-mm-dd format (from date input), convert to dd-mm-yyyy
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const [year, month, day] = dateString?.split("-");
      return `${day}-${month}-${year}`;
    }

    // For any other format, try to parse and format
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ""; // Invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    // If already in yyyy-mm-dd format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    // If in dd-mm-yyyy format, convert to yyyy-mm-dd
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    }

    // Try to parse as Date object
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return date.toISOString().split("T")[0];
    }

    return "";
  };

  // ------------------ PROFILE FETCH ------------------
  useEffect(() => {
    const fetchProfile = async () => {
      if (!id) {
        console.warn("No ID provided. Skipping profile fetch.");
        return;
      }
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${id}`
        );
        const profileData = response?.data?.profile;

        console.log(profileData, "ProfileData");
        if (response.statusCode === 200 && profileData) {
          setProfile({
            ["profile.name"]: profileData.name || "",
            ["profile.dob"]: profileData.dob || "",
            ["profile.age"]: profileData.age || "",
            ["profile.gender"]: profileData.gender || "",
            ["profile.district"]: profileData.district || "",
            ["profile.state"]: profileData.state || "",
            ["profile.mobile"]: profileData.mobile_number || "",
            ["profile.maritalStatus"]: profileData.maritalStatus || "",
            ["profile.religion"]: profileData.religion || "",
            ["profile.caste"]: profileData.caste || "",
            ["profile.profileImage"]: profileData.profileImage || "",
            ["profile.child_count"]: profileData.child_count || "",
            _id: profileData._id,
          });
          console.log("user_id---", id);
          dispatch(setUsername(profileData.name));
          setIsEditing(false);
        } else {
          console.warn("No profile found for this user.");
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
        setIsEditing(true);
      }
    };

    if (activeTab === "profile") {
      fetchProfile();
    }
  }, [activeTab, id]);
  //-------------------------Personal Fetch
  useEffect(() => {
    const fetchProfessional = async () => {
      if (!id) {
        console.warn("No ID provided. Skipping professional fetch.");
        return;
      }

      try {
        const response = await getWithTokenAPI(
          token,
          `/professional-profile/get_by_id?user_id=${id}`
        );
        const professionalData = response?.data;
        console.log(professionalData, "ProfessionalData");

        if (response.statusCode === 200 && professionalData) {
          const astrology = professionalData?.astrology || {};

          setProfessional({
            profession: professionalData?.profession || "",
            father_name: professionalData?.father_name || "",
            mother_name: professionalData?.mother_name || "",
            siblings: professionalData?.siblings || "",
            property_details: professionalData?.property_details || "",
            education: professionalData?.education || "",
            income: professionalData?.income || "",
            height: professionalData?.height || "",
            weight: professionalData?.weight || "",
            diet: professionalData?.diet || "",
            motherTongue: professionalData?.motherTongue || "",
            subCaste: professionalData?.subCaste || "",
            instagram: professionalData?.instagram || "",
            gallery: professionalData?.gallery || [],
            documentId: professionalData?.documentId || [],
            rasi: astrology?.rasi || "",
            natchathiram: astrology?.natchathiram || "",
            gothram: astrology?.gothram || "",
            laknam: astrology?.laknam || "",
            dosham: astrology?.dosham || "",
            kujaDosham: astrology?.kujaDosham || "",
            aboutMe: professionalData?.aboutMe || "",
            _id: professionalData?._id,
            instagram: professionalData.instagram,
          });

          setIsEditing(false);
        } else {
          console.warn("No professional data found for this user.");
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error fetching professional:", error);
        setIsEditing(true);
      }
    };

    if (activeTab === "photos") {
      fetchProfessional();
    }
  }, [activeTab, id]);
  // ----------------------FETCH PREFERENCE-----------------------
  useEffect(() => {
    const fetchPreference = async () => {
      if (!id) {
        console.warn("No ID provided. Skipping preference fetch.");
        return;
      }

      try {
        const response = await getWithTokenAPI(
          token,
          `/preference/get_by_id?user_id=${id}`
        );

        const preferenceData = response?.data;
        if (response.statusCode === 200 && preferenceData) {
          const getValue = (val) =>
            Array.isArray(val) ? val[0] || "" : val || "";

          // For multi-select fields, keep as arrays, for others use single value
          setPreference({
            min_age: preferenceData?.min_age || "",
            max_age: preferenceData?.max_age || "",
            min: preferenceData?.height_range?.min || "",
            max: preferenceData?.height_range?.max || "",
            marital_status: getValue(preferenceData?.marital_status),
            mother_tongue: getValue(preferenceData?.mother_tongue),
            gender: getValue(preferenceData?.gender_preference) || "",
            religion: Array.isArray(preferenceData?.religion)
              ? preferenceData.religion
              : [preferenceData?.religion || ""],
            caste: Array.isArray(preferenceData?.caste)
              ? preferenceData.caste
              : [preferenceData?.caste || ""],
            sub_caste: getValue(preferenceData?.sub_caste),
            education_level: getValue(preferenceData?.education_level),
            district: Array.isArray(preferenceData?.district)
              ? preferenceData.district
              : [preferenceData?.district || ""],
            state: preferenceData?.state || "",
            diet: getValue(preferenceData?.diet),
            family_status: getValue(preferenceData?.family_status),
            family_type: getValue(preferenceData?.family_type),
            family_values: getValue(preferenceData?.family_values),
            about_partner: preferenceData?.about_partner || "",
            _id: preferenceData?._id,
          });

          setIsEditing(false);
        } else {
          console.warn("No preference data found for this user.");
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error fetching preference:", error);
        setIsEditing(true);
      }
    };

    if (activeTab === "preferences") {
      fetchPreference();
    }
  }, [activeTab, id]);
  // ------------------ Zodiax FETCH ------------------
  useEffect(() => {
    const fetchzodiac = async () => {
      if (!id) {
        console.warn("No ID provided. Skipping preference fetch.");
        return;
      }
      try {
        const response = await getWithTokenAPI(
          token,
          `/zodiac/get_by_id?userId=${id}`
        );
        // alert('zodiac response',response.data)
        // console.log(response,'zodiacData-------response')
        const zodiacData = response?.data;
        console.log(zodiacData, "ZodiacData");

        if (response.statusCode === 200 && zodiacData) {
          // 🔹 Helper to safely unwrap arrays
          const getValue = (val) =>
            Array.isArray(val) ? val[0] || "" : val || "";

          setRasiBox({
            house1: zodiacData?.rasi?.House_1?.map((item) => item) || [],
            house2: zodiacData?.rasi?.House_2?.map((item) => item) || [],
            house3: zodiacData?.rasi?.House_3?.map((item) => item) || [],
            house4: zodiacData?.rasi?.House_4?.map((item) => item) || [],
            house5: zodiacData?.rasi?.House_5?.map((item) => item) || [],
            house6: zodiacData?.rasi?.House_6?.map((item) => item) || [],
            house7: zodiacData?.rasi?.House_7?.map((item) => item) || [],
            house8: zodiacData?.rasi?.House_8?.map((item) => item) || [],
            house9: zodiacData?.rasi?.House_9?.map((item) => item) || [],
            house10: zodiacData?.rasi?.House_10?.map((item) => item) || [],
            house11: zodiacData?.rasi?.House_11?.map((item) => item) || [],
            house12: zodiacData?.rasi?.House_12?.map((item) => item) || [],
            _id: zodiacData?._id,
          });
          console.log(rasibox, "rasiBox");

          setNavamsaBox({
            house1: zodiacData?.navamsa?.House_1?.map((item) => item) || [],
            house2: zodiacData?.navamsa?.House_2?.map((item) => item) || [],
            house3: zodiacData?.navamsa?.House_3?.map((item) => item) || [],
            house4: zodiacData?.navamsa?.House_4?.map((item) => item) || [],
            house5: zodiacData?.navamsa?.House_5?.map((item) => item) || [],
            house6: zodiacData?.navamsa?.House_6?.map((item) => item) || [],
            house7: zodiacData?.navamsa?.House_7?.map((item) => item) || [],
            house8: zodiacData?.navamsa?.House_8?.map((item) => item) || [],
            house9: zodiacData?.navamsa?.House_9?.map((item) => item) || [],
            house10: zodiacData?.navamsa?.House_10?.map((item) => item) || [],
            house11: zodiacData?.navamsa?.House_11?.map((item) => item) || [],
            house12: zodiacData?.navamsa?.House_12?.map((item) => item) || [],
            _id: zodiacData?._id,
          });

          setIsEditing(false);
        } else {
          console.warn("No zodiac data found for this user.");
          setIsEditing(true);
        }
      } catch (error) {
        console.error("Error fetching zodiac:", error);
      }
    };

    if (activeTab === "zodiac") {
      fetchzodiac();
    }
  }, [activeTab, id]);
  //----------------profile view count----------------
  useEffect(() => {
    const fetchview = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/profile-view-count/get_by_id?viewed_id=${id}`
        );
        if (response?.statusCode == 200) {
          setViewCount(response?.data?.total_views);
          // setviewerProfiles(response?.data?.viewer_profiles);
        } else {
        }
      } catch (error) {
        console.error("error in fetching views count");
      }
    };
    if (token) fetchview();
  }, [token, currentPage]);

  const [interestsent, setInterestSent] = useState(0);
  const [interestgot, setInterestGot] = useState(0);
  console.log("Interest Got", interestgot);
  console.log("Interest Sent", interestsent);
  //------------fetch interest-------------------
  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/interest/get_interest?user_id=${id}`
        );
        if (response) {
          setInterestGot(response?.data?.total_interests);
        } else {
          setInterestGot(0);
        }
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}`
        );
        if (sentresponse) {
          setInterestSent(sentresponse?.data?.total_sent);
        } else {
          setInterestSent(0);
        }
      } catch (error) {
        console.error("Error in fetching interests");
      }
    };
    fetchInterests();
  }, [id, token, currentPage]);

  //---------------------------------Matches Count--------------------------------
  const [matchcount, setMatchCount] = useState(0);
  useEffect(() => {
    const fetchmatchcount = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/profiles/matching?user_id=${id}`
        );
        setMatchCount(response?.data?.count);
      } catch {}
    };
    if (token) {
      fetchmatchcount();
    }
  }, [token, id, currentPage]);
  //----------------------------------------Message Count------------------------------------
  const [msgcount, setMsgCount] = useState(0);
  useEffect(() => {
    const fetchmsgcount = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/message/inbox?user_id=${id}`
        );
        setMsgCount(response?.data?.total);
      } catch {}
    };
    if (token) {
      fetchmsgcount();
    }
  }, [token, id, currentPage]);

  const handleSetPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    // You can add additional logic here when page changes
    console.log(`Navigated to page: ${pageNumber}`);
  };
  //-------------------------------Specific Image  Fetch --------------------------------
  // const [imageresponse, setimageresponse] = useState("");

  const [galleryUrl, setGalleryUrl] = useState([]);
  const [profileUrl, setProfileUrl] = useState("");
  console.log(galleryUrl, "GALLERYURL");
  useEffect(() => {
    const fetchpimages = async () => {
      const imageresponse = await getWithTokenAPI(
        token,
        `/document/user/${id}`
      );
      console.log(
        "Imageresponse-------------------------------",
        imageresponse?.data
      );
      setGalleryUrl(imageresponse?.data || []);
    };
    fetchpimages();
  }, [id, token]);
  //-----------Handle photo------
  const handlePhoto = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        toast.error(`{t("No file selected")}`);
        return;
      }
      const imageUrl = URL.createObjectURL(file);
      setProfileCropAspect(1);
      setProfileCropImage(imageUrl);
    } catch (error) {
      console.error("Error uploading photo:", error);
      toast.error(`${t("Failed to update profile photo")}`);
    }
  };

  const handleRasiChange = (e) => {
    const { name, value } = e.target;

    setRasiBox((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNavamsaChange = (e) => {
    const { name, value } = e.target;
    setNavamsaBox((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const age = new Date().getFullYear() - new Date(profile.dob).getFullYear();
  
  const validatebasicForm = (profile) => {
    const errors = {};

    // ✅ Basic Name
    if (
      !profile?.["profile.name"] ||
      profile["profile.name"]?.toString().trim() === ""
    ) {
      errors["profile.name"] = "Full name is required";
    } else if (profile["profile.name"].toString().trim().length < 3) {
      errors["profile.name"] = "Full name must be at least 3 characters";
    }

    if (!profile?.["profile.gender"]) {
      errors["profile.gender"] = "Gender is required";
    }

    // ✅ Basic DOB
    if (!profile?.["profile.dob"]) {
      errors["profile.dob"] = "Date of birth is required";
    }

    // ✅ Basic Age validation
    const age = profile?.["profile.age"];
    if (age && age < 18) {
      errors["profile.age"] = "Age must be greater than 18";
    }

    // Religion validation
    if (!profile?.["profile.religion"]) {
      errors["profile.religion"] = "Religion is required";
    }

    // ✅ Caste
    if (!profile?.["profile.caste"]) {
      errors["profile.caste"] = "Caste is required";
    }

    // ✅ Basic Marital Status
    if (!profile?.["profile.maritalStatus"]) {
      errors["profile.maritalStatus"] = "Marital status is required";
    }

    // ✅ State validation
    if (
      !profile?.["profile.state"] ||
      profile["profile.state"]?.toString().trim() === ""
    ) {
      errors["profile.state"] = "State is required";
    }

    // ✅ District validation
    if (
      !profile?.["profile.district"] ||
      profile["profile.district"]?.toString().trim() === ""
    ) {
      errors["profile.district"] = "District is required";
    }

    // Child count validation - only validate if it exists
    if (profile?.["profile.child_count"]) {
      const childrenNum = parseInt(profile["profile.child_count"]);
      if (isNaN(childrenNum) || childrenNum < 0 || childrenNum > 10) {
        errors["profile.child_count"] =
          "Please enter a number between 0 and 10";
      }
    }

    return errors;
  };

  // ------------------Validate personal/professional/photos form------------
  const validatePersonalForm = (professional) => {
    const errors = {};

    // ✅ Height validation
    if (
      !professional?.height ||
      professional.height?.toString().trim() === ""
    ) {
      errors.height = "Height is required";
    } else {
      const heightValue = professional.height.toString().trim();
      if (!/^\d+$/.test(heightValue)) {
        errors.height = "Height must be a number";
      } else {
        const heightNum = parseInt(heightValue);
        if (heightNum < 100 || heightNum > 250) {
          errors.height = "Height must be between 100cm and 250cm";
        }
      }
    }

    // ✅ Mother Tongue validation
    if (
      !professional?.motherTongue ||
      professional.motherTongue?.toString().trim() === ""
    ) {
      errors.motherTongue = "Mother tongue is required";
    }

    // ✅ Education validation
    if (
      !professional?.education ||
      professional.education?.toString().trim() === ""
    ) {
      errors.education = "Education is required";
    }

    // ✅ Diet validation
    if (!professional?.diet || professional.diet?.toString().trim() === "") {
      errors.diet = "Diet is required";
    }

    // ✅ Siblings validation
    if (
      !professional?.siblings ||
      professional.siblings?.toString().trim() === ""
    ) {
      errors.siblings = "Siblings information is required";
    }

    // ✅ About Me validation
    if (
      !professional?.aboutMe ||
      professional.aboutMe?.toString().trim() === ""
    ) {
      errors.aboutMe = "About me is required";
    } else if (professional.aboutMe.toString().trim().length < 10) {
      errors.aboutMe = "About me must be at least 10 characters";
    }

    return errors;
  };

  // -------------------validate preference form-------------
  const validatePreferencesForm = (preference) => {
    const errors = {};

    // ✅ Min Height validation
    if (!preference?.min || preference.min?.toString().trim() === "") {
      errors.min = "Minimum height is required";
    } else {
      const minValue = preference.min.toString().trim();
      if (!/^\d+$/.test(minValue)) {
        errors.min = "Minimum height must be a number";
      } else {
        const minNum = parseInt(minValue);
        if (minNum < 100 || minNum > 250) {
          errors.min = "Minimum height must be between 100cm and 250cm";
        }
      }
    }

    // ✅ Max Height validation
    if (!preference?.max || preference.max?.toString().trim() === "") {
      errors.max = "Maximum height is required";
    } else {
      const maxValue = preference.max.toString().trim();
      if (!/^\d+$/.test(maxValue)) {
        errors.max = "Maximum height must be a number";
      } else {
        const maxNum = parseInt(maxValue);
        if (maxNum < 100 || maxNum > 250) {
          errors.max = "Maximum height must be between 100cm and 250cm";
        }
      }
    }

    // ✅ Height range validation
    if (preference?.min && preference?.max) {
      const minNum = parseInt(preference.min.toString().trim());
      const maxNum = parseInt(preference.max.toString().trim());
      if (minNum > maxNum) {
        errors.max = "Maximum height cannot be less than minimum height";
      }
    }

    // ✅ Mother Tongue validation
    if (
      !preference?.mother_tongue ||
      preference.mother_tongue?.toString().trim() === ""
    ) {
      errors.mother_tongue = "Mother tongue is required";
    }

    // ✅ Caste validation
    if (
      !preference?.caste ||
      !Array.isArray(preference.caste) ||
      preference.caste.length === 0 ||
      (preference.caste.length === 1 &&
        preference.caste[0]?.toString().trim() === "")
    ) {
      errors.caste = "Caste preference is required";
    }

    // ✅ Religion validation
    if (
      !preference?.religion ||
      !Array.isArray(preference.religion) ||
      preference.religion.length === 0 ||
      (preference.religion.length === 1 &&
        preference.religion[0]?.toString().trim() === "")
    ) {
      errors.religion = "Religion preference is required";
    }

    // ✅ State validation
    if (!preference?.state || preference.state?.toString().trim() === "") {
      errors.state = "State preference is required";
    }

    // ✅ District validation
    if (
      !preference?.district ||
      !Array.isArray(preference.district) ||
      preference.district.length === 0 ||
      (preference.district.length === 1 &&
        preference.district[0]?.toString().trim() === "")
    ) {
      errors.district = "District preference is required";
    }

    // ✅ Education Level validation
    if (
      !preference?.education_level ||
      preference.education_level?.toString().trim() === ""
    ) {
      errors.education_level = "Education level preference is required";
    }

    // ✅ Marital Status validation
    if (
      !preference?.marital_status ||
      preference.marital_status?.toString().trim() === ""
    ) {
      errors.marital_status = "Marital status preference is required";
    }

    // ✅ Family Status validation
    if (
      !preference?.family_status ||
      preference.family_status?.toString().trim() === ""
    ) {
      errors.family_status = "Preferred Family status is required";
    }

    // ✅ Gender validation
    if (!preference?.gender || preference.gender?.toString().trim() === "") {
      errors.gender = "Preferred Gender is required";
    }

    // ✅ Family Type validation
    if (
      !preference?.family_type ||
      preference.family_type?.toString().trim() === ""
    ) {
      errors.family_type = "Preferred Family type is required";
    }

    // ✅ Family Values validation
    if (
      !preference?.family_values ||
      preference.family_values?.toString().trim() === ""
    ) {
      errors.family_values = "Preferred Family values is required";
    }

    // ✅ About Partner validation
    if (
      !preference?.about_partner ||
      preference.about_partner?.toString().trim() === ""
    ) {
      errors.about_partner = "About partner is required";
    }

    return errors;
  };
  // this useEffect to clear errors when user types
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setErrors({});
    }
  }, [profile, professional, preference]); //clear errors whenever state changes

  // Update handleProfileFieldChange
  const handleProfileFieldChange = (field, value) => {
    setProfile({
      ...profile,
      [field]: value,
    });

    // Auto-calculate age when DOB changes
    if (field === "profile.dob" && value) {
      const calculatedAge = calculateAge(value);
      setProfile((prev) => ({
        ...prev,
        "profile.age": calculatedAge,
      }));
    }

    // Clear error for this specific field when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleSave = async () => {
    try {
      if (token || id) {
        if (activeTab == "profile") {
          const formErrors = validatebasicForm(profile);

          if (formErrors && Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            toast.error(`${t("Please fix the errors before saving.")}`);
            return;
          }
          setErrors({});

          const payload = {
            name: profile["profile.name"],
            district: capitalize(profile["profile.district"]),
            state: capitalize(profile["profile.state"]),
            dob: formatDate(profile["profile.dob"]), // This uses your existing formatDate function
            age: profile["profile.age"],
            gender: profile["profile.gender"],
            religion: capitalize(profile["profile.religion"]),
            caste: profile["profile.caste"],
            maritalStatus: profile["profile.maritalStatus"],
            child_count: profile["profile.child_count"],
            user_id: id,
          };

          console.log("profile payload", payload);

          if (profile && profile?._id) {
            const response = await putWithTokenAPI(
              token,
              `/basic-profile/update?user_id=${id}`,
              payload
            );
            console.log("Profile updated:", response);
            if (response?.statusCode == 200) {
              toast.success(`${t("Profile updated successfully!")}`); // ✅ ADDED THIS
            } else {
              toast.error(`${t("Profile Updation Unsuccessful")}`);
            }
          } else {
            const response = await postWithTokenAPI(
              token,
              "/basic-profile/create",
              payload
            );
            console.log("response", response.data._id);
            if (response?.statusCode == 200) {
              toast.success(`${t("Profile created successfully!")}`);
              console.log("profile creation done");
              headerRef.current?.fetchAllDetails();
            } else {
              toast.error(`${t("Profile creation Unsuccessful")}`);
            }
          }
        } else if (activeTab === "photos") {
          const formErrors = validatePersonalForm(professional);
          if (formErrors && Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            toast.error(`${t("Please fix the errors before saving.")}`);
            return;
          }
          // Clear errors if validation passes
          setErrors({});
          const payload = {
            father_name: capitalize(professional.father_name),
            mother_name: capitalize(professional.mother_name),
            profession: capitalize(professional.profession),
            siblings: capitalize(professional.siblings),
            mother_name: capitalize(professional.mother_name),
            property_details: capitalize(professional.property_details),
            education: capitalize(professional.education),
            instagram: professional.instagram,
            income: professional.income,
            height: professional.height,
            weight: professional.weight,
            diet: professional.diet,
            subCaste: capitalize(professional.subCaste),
            religion: capitalize(professional.religion),
            motherTongue: capitalize(professional.motherTongue),
            astrology: {
              rasi: capitalize(professional.rasi),
              natchathiram: capitalize(professional.natchathiram),
              gothram: capitalize(professional.gothram),
              laknam: capitalize(professional.laknam),
              dosham: professional.dosham,
              kujaDosham: professional.kujaDosham,
            },
            aboutMe: professional.aboutMe,
            user_id: id,
          };

          if (professional && professional?._id) {
            const response = await putWithTokenAPI(
              token,
              `/professional-profile/update?user_id=${id}`,
              payload
            );
            console.log("Professional updated:", response);
            if (response?.statusCode == 200) {
              toast.success(`${t("Personal details updated successfully!")}`); // ✅ ADDED THIS
            } else {
              toast.error(`${t("Personal details Updation Unsuccessful")}`);
            }
          } else {
            const response = await postWithTokenAPI(
              token,
              `/professional-profile/create`,
              payload
            );

            if (response?.statusCode == 200) {
              headerRef.current?.fetchAllDetails();
              toast.success(`${t("Personal details saved successfully!")}`);
              const professionalid = response?.data._id;
              dispatch(setProfessionalId(professionalid));
            } else {
              toast.error(`${t("Personal Details not saved")}`);
            }

            console.log("Professional created:", response);
          }
        } else if (activeTab === "preferences") {
          if (!preference) {
            console.error("Preference data is undefined");
            toast.error(`${t("Preference data not loaded properly")}`);
            return;
          }
          const formErrors = validatePreferencesForm(preference);
          if (formErrors && Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            console.log(formErrors, "FORMERRORS");
            toast.error(`${t("Please fix the errors before saving.")}`);
            return;
          }
          setErrors({});
          const payload = {
            user_id: id,
            min_age: preference.min_age || "",
            max_age: preference.max_age || "",
            height_range: {
              min: preference.min || "",
              max: preference.max || "",
            },
            marital_status: preference.marital_status || "",
            mother_tongue: capitalize(preference.mother_tongue) || "",
            gender_preference: preference.gender || "",
            religion: Array.isArray(preference.religion)
              ? preference.religion.map((item) => capitalize(item))
              : [capitalize(preference.religion || "")],
            caste: Array.isArray(preference.caste)
              ? preference.caste.map((item) => capitalize(item))
              : [capitalize(preference.caste || "")],
            sub_caste: capitalize(preference.sub_caste) || "",
            education_level: capitalize(preference.education_level) || "",
            district: Array.isArray(preference.district)
              ? preference.district.map((item) => capitalize(item))
              : [capitalize(preference.district || "")],
            state: capitalize(preference.state) || "",
            family_status: preference.family_status || "",
            family_type: preference.family_type || "",
            family_values: preference.family_values || "",

            about_partner: capitalize(preference.about_partner) || "",
          };
          if (preference && preference?._id) {
            const response = await putWithTokenAPI(
              token,
              `/preference/update?user_id=${id}`,
              payload
            );
            if (response?.statusCode == 200) {
              console.log("Preference updated:", response);
              toast.success(`${t("Preferences updated successfully!")}`); // ✅ ADDED THIS
            } else {
              toast.error(`${t("Prefernces Updation Unsuccessful")}`);
            }
          } else {
            const response = await postWithTokenAPI(
              token,
              `/preference/create`,
              payload
            );
            if (response?.statusCode == 200) {
              headerRef.current?.fetchAllDetails();
              const preferenceid = response?.data?._id;
              dispatch(setPreferenceId(preferenceid));
               toast.success(t("Preferences saved successfully!"));
              console.log("Preference created:", response);
            } else {
              toast.error(`${t("Preferences not saved")}`);
            }
          }
        } else if (activeTab === "zodiac") {
          console.log("Zodiac tab logic running...");
          console.log("rasibox:", rasibox);
          console.log("navamsabox:", navamsabox);

          const makeHouseObject = (source) => {
            const result = {};

            for (let i = 1; i <= 12; i++) {
              const key = `House_${i}`;
              const rawValue = source[`house${i}`];

              if (rawValue) {
                // Convert string → array
                const arr =
                  typeof rawValue === "string"
                    ? rawValue
                        .split(",") // split by comma
                        .map((v) => v.trim()) // remove spaces
                        .filter(Boolean) // remove empty values
                    : rawValue; // already array

                if (arr.length > 0) {
                  result[key] = arr;
                }
              }
            }

            return result;
          };

          const payload = {
            userId: id,
            rasi: makeHouseObject(rasibox),
            navamsa: makeHouseObject(navamsabox),
          };

          try {
            if (zodiacid) {
              console.log("Updating zodiac...");
              const response = await putWithTokenAPI(
                token,
                `/zodiac/update?user_id=${id}`,
                payload
              );
              console.log("Update Response:", response);
              if (response?.statusCode == 200) {
                toast.success(`${t("Zodiac details updated successfully!")}`);
              } else {
                toast.error(`${t("Zodiax details updation Unsuccessful")}`);
              }
            } else {
              console.log("Creating new zodiac...");
              const response = await postWithTokenAPI(
                token,
                `/zodiac/create`,
                payload
              );
              if (response?.statusCode == 200) {
                headerRef.current?.fetchAllDetails();
                console.log("Create Response:", response);
                dispatch(setZodiacId(response?.data._id));
                toast.success(`${t("Zodiac details saved successfully!")}`);
              } else {
                toast.error(`${t("Kindly check Field values")}`);
              }
            }
          } catch (error) {
            console.error("Error saving zodiac:", error);
            toast.error(
              `${t("Failed to save zodiac details. Please try again.")}`
            );
          }
        }
      }
      setIsEditing(false);
    } catch (error) {
      console.log("alert error", error);
      // alert("this error");
      toast.error(`${t("Failed to save data. Please try again.")}`);
    }
  };

  // ✅ Auto-enable edit mode for new users
  useEffect(() => {
    if (!profile._id) {
      setIsEditing(true);
    }
  }, [profile]);

  const headerRef = useRef();

  const [userSubscription, setUserSubscription] = useState({
    plan_id: "",
    plan_price: "",
    plan_name: "",
    status: "",
    amount: "",
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${id}`
        );

        const profile = response?.data?.profile;
        const subpack = response?.data?.subscription;

        if (profile) {
          setprofileData(profile.name);
        }

        if (subpack) {
          setSubsPack(subpack);

          setUserSubscription({
            plan_id: subpack.plan_id || "",
            plan_price: subpack.price || "",
            plan_name: subpack.plan_name || "",
            status: subpack.status || "",
            amount: subpack.price || "",
            start_date: subpack.start_date || "",
            end_date: subpack.end_date || "",
          });
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    if (id && token) fetchProfile();
  }, [id, token]);

  // const formatDateWithOrdinal = (dateString) => {
  //   if (!dateString) return "";
  //   const date = new Date(dateString);
  //   const day = date.getDate();
  //   const month = date.toLocaleDateString("en-US", { month: "long" });
  //   const year = date.getFullYear();
  //   const suffix = (n) =>(
  //     n > 3 && n < 21 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th";
  //     return `${day}${suffix(day)} ${month} ${year}`);
  // };
  const formatDateWithOrdinal = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    // Handle invalid dates
    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleDateString("en-US", { month: "long" });
    const year = date.getFullYear();

    const suffix = (n) =>
      n > 3 && n < 21 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th";

    return `${day}${suffix(day)} ${month} ${year}`;
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Toaster position="top-right" />
      <Header ref={headerRef} update={1} />

      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-4 mt-2">
            <User className="w-8 h-8 text-gray-700 mb-2" />
            <h1 className="text-2xl font-semibold mt-2">{t("My Profile")}</h1>
          </div>
          {currentPage == 0 && (
            <div className="flex items-center gap-2">
              <Button
                variant={isEditing ? "default" : "outline"}
                onClick={() => {
                  setIsEditing(true);
                }}
                className="flex items-center gap-2 cursor-pointer"
              >
                <>
                  <Edit2 className="w-4 h-4" />
                  {t("Edit Profile")}
                </>
              </Button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-7.5xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 ">
          {/* Left Sidebar */}
          <div className="space-y-6 ">
            <Card className="mb-4">
              <CardHeader>
                <CardTitle className="font-semibold font-muted-forground text-xl">
                  {t("Profile Stats")}
                </CardTitle>
              </CardHeader>
              <CardContent
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent:'center',
                  gap: "8px",
                }}
              >
                {[
                  {
                    label: t("Profile"),
                    page: 0,
                    value: null,
                    icon: <User className="w-5 h-5 mb-1" />,
                  },
                  {
                    label: t("Profile Views"),
                    page: 1,
                    value: viewcount,
                    icon: <Eye className="w-5 h-5" />,
                  },
                  {
                    label: t("Interests Sent"),
                    page: 3,
                    value: interestsent,
                    icon: <Send className="w-5 h-5" />,
                  },
                  {
                    label: t("Interests Received"),
                    page: 2,
                    value: interestgot,
                    icon: <HeartHandshake className="w-5 h-5" />,
                  },
                  {
                    label: t("Payment"),
                    page: 6,
                    icon: <CreditCard className="w-5 h-5" />,
                  },
                  {
                    label: t("Matches"),
                    page: 4,
                    value: matchcount,
                    navigate: "/matches",
                    icon: <Users className="w-5 h-5" />,
                  },
                  {
                    label: t("Messages"),
                    page: 5,
                    value: msgcount,
                    navigate: "/messages",
                    icon: <MessageCircle className="w-5 h-5" />,
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    onClick={() => {
                      if (item.navigate) {
                        navigate(item.navigate);
                      } else {
                        handleSetPage(item.page);
                      }
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "12px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      backgroundColor:
                        currentPage === item.page ? "#FEF2F2" : "transparent",
                      border:
                        currentPage === item.page
                          ? "1px solid #FECACA"
                          : "none",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => {
                      if (currentPage !== item.page) {
                        e.currentTarget.style.backgroundColor = "#f5f5f5";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (currentPage !== item.page) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <span
                        style={{
                          color:
                            currentPage === item.page ? "#DC2626" : "#6B7280",
                        }}
                      >
                        {item.icon}
                      </span>

                      <span
                        style={{
                          fontWeight: 500,
                          color:
                            currentPage === item.page ? "#DC2626" : "#6B7280",
                        }}
                      >
                        {item.label}
                      </span>
                    </div>

                    {item.value !== null && (
                      <span
                        style={{
                          fontWeight: 600,
                          color:
                            currentPage === item.page ? "#DC2626" : "#111827",
                        }}
                      >
                        {item.value}
                      </span>
                    )}
                  </div>
                ))}
              </CardContent>
            </Card>

            {userSubscription.start_date &&
              userSubscription.plan_name &&
              userSubscription.end_date && (
                <Card className={`mb-4 ${userSubscription.plan_name==='Premium'?'bg-blue-50': userSubscription.plan_name === 'Elite' ? 'bg-purple-50' : 'bg-green-50'} shadow-md rounded-xl cursor-pointer`} onClick={()=>{
                  navigate('/subscription')
                }}>
                  <CardContent
                    style={{
                      padding: "1.5rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "1.25rem",
                    }}
                  >
                    <div className={`p-3 rounded-xl border shadow-md`}>
                      {userSubscription.plan_name=='Elite'?<Crown className=" text-purple-600 h-7 w-7"/>:userSubscription.plan_name=='Premium'?<Star className=" text-blue-600 h-7 w-7"/>:<Feather className="text-green-600 h-7 w-7"/> }
                    </div>
                    <div>
                      <p className="text-lg ">
                        <span className="font-semibold">
                          {t("Current Plan:")}
                        </span>{" "}
                        {userSubscription.plan_name}
                      </p>

                      <div className="mt-1 text-sm space-y-1">
                        <p className="text-green-800">
                          <span className="font-semibold">Start:</span>{" "}
                          {formatDateWithOrdinal(userSubscription.start_date)}
                        </p>

                        <p className="text-green-800">
                          <span className="font-semibold">End:</span>{" "}
                          {formatDateWithOrdinal(userSubscription.end_date)}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )} 
            <Card>
              <CardContent className="pt-6 space-y-4">
                <Button
                  onClick={() => navigate("/subscription")}
                  className="w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                >
                  {t("Upgrade to Premium")}
                </Button>

                <Button
                  onClick={() => setOpenConfirm(true)}
                  className="w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                >
                  {t("Delete Account")}
                </Button>
              </CardContent>
            </Card>
          </div>

          {/* Main Section */}
          {currentPage == 0 && (
            <div className="lg:col-span-3">
              <Tabs value={activeTab} onValueChange={setActiveTab}>
                <TabsList className="flex justify-start w-full overflow-x-auto whitespace-nowrap rounded-xl bg-gray-100 p-1 m-8 sm:grid-cols-1 w-full overflow-x-auto scrollbar-hide cursor-pointer"   style={{
    scrollbarWidth: 'none', /* Firefox */
    msOverflowStyle: 'none', /* IE/Edge */
  }}>
                  <TabsTrigger
                    className="cursor-pointer"
                    id="b_info"
                    value="profile"
                  >
                    {t("Basic Info")}
                  </TabsTrigger>
                  <TabsTrigger className="cursor-pointer" value="photos">
                    {t("Personal Info")}
                  </TabsTrigger>
                  <TabsTrigger className="cursor-pointer" value="preferences">
                    {t("Preferences")}
                  </TabsTrigger>
                  <TabsTrigger className="cursor-pointer" value="zodiac">
                    {t("Zodiac Details")}
                  </TabsTrigger>
                </TabsList>

                {/* Profile Tab */}
                <TabsContent
                  value="profile"
                  className="space-y-6 cursor-pointer"
                >
                  <Card>
                    <CardHeader>
                      <CardTitle>{t("Basic Information")}</CardTitle>
                      <CardDescription>
                        {t("Update your basic profile information")}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      {/* Profile Photo Section - UNCHANGED */}
                      {/* Profile Photo Section */}
<div className="flex items-center">
  <div className="relative">
    <Avatar className="w-24 h-24">
      <AvatarImage
        src={
          profile["profile.profileImage"] ||
          profile["profile.name"]
        }
        alt={"User Avatar"}
        className="object-contain bg-gray-100"
        onError={(e) => (e.target.src = "")}
      />
      <AvatarFallback  className="text-center text-xl py-1">
              {profileData
              .split(" ")
              .map((n) => n[0]?.toUpperCase())
              .join("")}
      </AvatarFallback>
    </Avatar>
    <>
      <input
        type="file"
        id="profile-upload"
        className="hidden"
        onChange={handlePhoto}
        accept="image/*"
      />
      <Button
        variant="secondary"
        size="icon"
        className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-white shadow-md border-2 border-gray-300 hover:bg-gray-100 hover:shadow-lg transition-all cursor-pointer"
        onClick={() =>
          document
            .getElementById("profile-upload")
            .click()
        }
      >
        <Edit2 className="w-5 h-5 text-gray-700" />
      </Button>
    </>
  </div>
</div>

{/* Profile Image Crop Dialog */}
{profileCropImage && (
  <>
    <div className="fixed inset-0 bg-black/40 backdrop-blur-md z-40"></div>
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-[90%] max-w-md max-h-[40vh] flex flex-col">
        <div className="p-3 border-b border-gray-100 flex justify-between items-center flex-shrink-0">
          <div>
            <h3 className="font-semibold text-gray-900 text-md">
              {t("Crop Profile Image")}
            </h3>
            <p className="text-xs text-gray-600 mt-1">
              {t("Adjust the crop area for your profile picture")}
            </p>
          </div>
          <button
            onClick={() => {
              setProfileCropImage(null);
              setProfileCrop(undefined);
              setProfileCompletedCrop(undefined);
              setProfileCropAspect(1);
            }}
            className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1 rounded-full transition-colors cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex items-center justify-center gap-2 px-3 pt-2 flex-shrink-0">
          <button
            type="button"
            onClick={() => {
              setProfileCropAspect(1);
              if (profileImgRef.current) {
                const { width, height } = profileImgRef.current;
                setProfileCrop(centerAspectCrop(width, height, 1));
              }
            }}
            className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium border transition-colors cursor-pointer ${
              profileCropAspect === 1
                ? "bg-red-500 text-white border-red-500"
                : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
            }`}
          >
            <Square className="w-3 h-3" />
            {t("Square")}
          </button>
          <button
            type="button"
            onClick={() => {
              setProfileCropAspect(undefined);
              setProfileCrop(getFullImageCrop());
            }}
            className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium border transition-colors cursor-pointer ${
              profileCropAspect === undefined
                ? "bg-red-500 text-white border-red-500"
                : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
            }`}
          >
            <Crop className="w-3 h-3" />
            {t("Full Image")}
          </button>
        </div>

        <div className="flex-1 overflow-auto p-3">
          <div className="flex justify-center items-center h-full">
            {profileCropImage && (
              <div className="max-w-full max-h-[20vh]">
                <ReactCrop
                  crop={profileCrop}
                  onChange={(_, percentCrop) => setProfileCrop(percentCrop)}
                  onComplete={(c) => setProfileCompletedCrop(c)}
                  aspect={profileCropAspect}
                >
                  <img
                    ref={profileImgRef}
                    alt="Crop"
                    src={profileCropImage}
                    className="max-h-[18vh] max-w-full object-contain"
                    onLoad={(e) => {
                      const { width, height } = e.currentTarget;
                      setProfileCrop(
                        profileCropAspect
                          ? centerAspectCrop(width, height, profileCropAspect)
                          : getFullImageCrop()
                      );
                    }}
                  />
                </ReactCrop>
              </div>
            )}
          </div>
        </div>

        <div className="p-3 border-t border-gray-100 bg-gray-50 flex gap-2 flex-shrink-0">
          <button
            onClick={() => {
              setProfileCropImage(null);
              setProfileCrop(undefined);
              setProfileCompletedCrop(undefined);
              setProfileCropAspect(1);
            }}
            className="flex-1 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100 font-medium transition-colors text-sm cursor-pointer"
          >
            {t("Cancel")}
          </button>

          <button
            onClick={handleProfileCropAndUpload}
            disabled={!profileCompletedCrop}
            className="flex-1 py-2 bg-gradient-to-br from-red-500 to-pink-600 text-white rounded disabled:bg-gray-400 disabled:cursor-not-allowed font-medium transition-colors text-sm cursor-pointer"
          >
            {t("Save Photo")}
          </button>
        </div>
      </div>
    </div>
  </>
)}

                      {/* UPDATED FORM FIELDS - Matching Register Page */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {[
                          ["profile.name", "Full Name", "text"],
                          ["profile.mobile", "Mobile", "text"],
                          ["profile.dob", "Date of Birth", "date"],
                          ["profile.age", "Age", "number"],
                        ].map(([id, label, type]) => {
                          let inputValue = profile[id] || "";
                          if (type === "date" && inputValue) {
                            inputValue = formatDateForInput(inputValue);
                          }
                          const isDisabled =
                            id === "profile.mobile"
                              ? true
                              : !isEditing || id === "profile.age";
                          return (
                            <div key={id} className="space-y-2">
                              <Label
                                htmlFor={id}
                                className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                              >
                                {t(label)}
                                <span className="text-red-500">*</span>
                              </Label>
                              <Input
                                id={id}
                                value={inputValue}
                                type={type}
                                disabled={isDisabled}
                                onChange={(e) =>
                                  handleProfileFieldChange(id, e.target.value)
                                }
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 placeholder:text-gray-700 text-black
            ${errors[id] ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              isDisabled
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                                placeholder={
                                  id === "profile.age" ? "Auto-calculated" : ""
                                }
                              />
                              {errors[id] && (
                                <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                  {errors[id]}
                                </p>
                              )}
                            </div>
                          );
                        })}

                        {/* Gender Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("Gender")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <Select
                            value={profile["profile.gender"] || ""}
                            disabled={!isEditing}
                            onValueChange={(value) =>
                              handleProfileFieldChange("profile.gender", value)
                            }
                          >
                            <SelectTrigger
                              className={`
          h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200 text-black
          ${
            errors["profile.gender"] ? "border-red-500 ring-2 ring-red-200" : ""
          }
          ${
            !isEditing
              ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700 text-black"
          }
        `}
                            >
                              <SelectValue placeholder={t("Select Gender")} />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                              <SelectItem value="Male" className="rounded-lg">
                                {t("Male")}
                              </SelectItem>
                              <SelectItem value="Female" className="rounded-lg">
                                {t("Female")}
                              </SelectItem>
                              <SelectItem value="Other" className="rounded-lg">
                                {t("Other")}
                              </SelectItem>
                            </SelectContent>
                          </Select>
                          {errors["profile.gender"] && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors["profile.gender"]}
                            </p>
                          )}
                        </div>

                        {/* Religion Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("Religion")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <ReactSelect
                            value={
                              profile["profile.religion"]
                                ? {
                                    value: profile["profile.religion"], // English value
                                    label: t(profile["profile.religion"]), // Tamil translation for display
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              handleProfileFieldChange(
                                "profile.religion",
                                selectedOption ? selectedOption.value : "" // English value for state
                              )
                            }
                            options={religionOption.map((option) => ({
                              value: option.value, // English value for API
                              label: t(option.value), // Tamil translation for display
                            }))}
                            placeholder={t("Select Religion")}
                            isClearable
                            isDisabled={!isEditing}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            classNames={{
                              control: (state) => `
        h-10 rounded-l border transition-all duration-200 text-sm text-black
        ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
        ${
          errors["profile.religion"] ? "border-red-500 ring-2 ring-red-200" : ""
        }
        ${
          !isEditing
            ? "bg-gray-100 border-none cursor-not-allowed"
            : "bg-gray-100 border-black hover:border-gray-700"
        }
      `,
                              option: (state) => `
        text-sm px-3 py-2 cursor-pointer rounded-lg
        ${
          state.isSelected
            ? "bg-red-500 text-white"
            : state.isFocused
            ? "bg-red-50 text-red-700"
            : "text-gray-900"
        }
      `,
                              menu: () =>
                                "rounded-l border border-gray-200 shadow-lg mt-1",
                              menuList: () => "py-1",
                              placeholder: () => "text-gray-400",
                              singleValue: () =>
                                `${
                                  !isEditing ? "text-gray-600" : "text-black"
                                }`,
                              indicatorSeparator: () => "bg-gray-300",
                              dropdownIndicator: () =>
                                "text-gray-400 hover:text-gray-600",
                              clearIndicator: () =>
                                "text-gray-400 hover:text-gray-600",
                            }}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "31px",
                                height: "31px",
                                borderRadius: "8px",
                                boxShadow: "none",
                                // border: !isEditing
                                //   ? "none"
                                //   : "1px solid #000",
                                backgroundColor: "#f5f5f5ff",
                                // "&:hover": {
                                //   borderColor: !isEditing
                                //     ? "none"
                                //     : "#374151",
                                // },
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "31px",
                                padding: "0 12px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: "0",
                                padding: "0",
                                color: !isEditing ? "#6b7280" : "#000000",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "31px",
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? "#999a9dff"
                                  : state.isFocused
                                  ? "#cbcccfff"
                                  : "white",
                                color: state.isSelected
                                  ? "white"
                                  : state.isFocused
                                  ? "#363636ff"
                                  : "#0f0f0fff",
                                "&:active": {
                                  backgroundColor: state.isSelected
                                    ? "#bcbdc0ff"
                                    : "#9a9fa8ff",
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: "8px",
                                border: "1px solid #e5e7eb",
                                boxShadow:
                                  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                overflow: "hidden",
                              }),
                            }}
                          />
                          {errors["profile.religion"] && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors["profile.religion"]}
                            </p>
                          )}
                        </div>

                        {/* Caste Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("Caste")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <Select
                            value={profile["profile.caste"] || ""}
                            disabled={!isEditing}
                            onValueChange={(value) =>
                              handleProfileFieldChange("profile.caste", value)
                            }
                          >
                            <SelectTrigger
                              className={`
          h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200 text-black
          ${errors["profile.caste"] ? "border-red-500 ring-2 ring-red-200" : ""}
          ${
            !isEditing
              ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700 text-black"
          }
        `}
                            >
                              <SelectValue placeholder={t("Select Caste")} />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg max-h-60 overflow-y-auto">
                              <SelectItem value="Nadar">
                                {t("Nadar")}
                              </SelectItem>
                              <SelectItem value="Pillai">
                                {t("Pillai")}
                              </SelectItem>
                              <SelectItem value="Naidu">
                                {t("Naidu")}
                              </SelectItem>
                              <SelectItem value="Ilathu Pillai">
                                {t("Ilathu Pillai")}
                              </SelectItem>
                              <SelectItem value="Vishwakarma">
                                {t("Vishwakarma")}
                              </SelectItem>
                              <SelectItem value="Saiva Pillai">
                                {t("Saiva Pillai")}
                              </SelectItem>
                              <SelectItem value="Kallar">
                                {t("Kallar")}
                              </SelectItem>
                              <SelectItem value="Maravar">
                                {t("Maravar")}
                              </SelectItem>
                              <SelectItem value="Agamudaiyar">
                                {t("Agamudaiyar")}
                              </SelectItem>
                              <SelectItem value="Chettiyar">
                                {t("Chettiyar")}
                              </SelectItem>
                              <SelectItem value="Christian">
                                {t("Christian")}
                              </SelectItem>
                              <SelectItem value="Muslim">
                                {t("Muslim")}
                              </SelectItem>
                              <SelectItem value="Maruthuvar">
                                {t("Maruthuvar")}
                              </SelectItem>
                              <SelectItem value="Sourashtra">
                                {t("Sourashtra")}
                              </SelectItem>
                              <SelectItem value="Vanniyar">
                                {t("Vanniyar")}
                              </SelectItem>
                              <SelectItem value="Naicker">
                                {t("Naicker")}
                              </SelectItem>
                              <SelectItem value="Muppanar">
                                {t("Muppanar")}
                              </SelectItem>
                              <SelectItem value="Veerasaivam">
                                {t("Veerasaivam")}
                              </SelectItem>
                              <SelectItem value="Malayali">
                                {t("Malayali")}
                              </SelectItem>
                              <SelectItem value="Kulalar">
                                {t("Kulalar")}
                              </SelectItem>
                              <SelectItem value="Iyer">{t("Iyer")}</SelectItem>
                              <SelectItem value="Iyengar">
                                {t("Iyengar")}
                              </SelectItem>
                              <SelectItem value="Mudaliyar">
                                {t("Mudaliyar")}
                              </SelectItem>
                              <SelectItem value="Yadavar">
                                {t("Yadavar")}
                              </SelectItem>
                              <SelectItem value="Reddy">
                                {t("Reddy")}
                              </SelectItem>
                              <SelectItem value="Vannar">
                                {t("Vannar")}
                              </SelectItem>
                              <SelectItem value="Doctor">
                                {t("Doctor")}
                              </SelectItem>
                              <SelectItem value="Adi Dravidar">
                                {t("Adi Dravidar")}
                              </SelectItem>
                              <SelectItem value="Devendra Kula Vellalar">
                                {t("Devendra Kula Vellalar")}
                              </SelectItem>
                              <SelectItem value="Arunthathiyar">
                                {t("Arunthathiyar")}
                              </SelectItem>
                              <SelectItem value="Kolandar">
                                {t("Kolandar")}
                              </SelectItem>
                              <SelectItem value="No Caste Barrier">
                                {t("Prefer not to say")}
                              </SelectItem>
                            </SelectContent>
                          </Select>
                          {errors["profile.caste"] && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors["profile.caste"]}
                            </p>
                          )}
                        </div>

                        {/* State Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("State")} <span className="text-red-500">*</span>
                          </Label>
                          <Select
                            disabled={!isEditing}
                            value={profile["profile.state"] || ""}
                            onValueChange={(value) => {
                              handleProfileFieldChange("profile.state", value);
                              if (value) {
                                fetchDistricts(value);
                              } else {
                                setDistricts([]);
                                handleProfileFieldChange(
                                  "profile.district",
                                  ""
                                );
                              }
                            }}
                          >
                            <SelectTrigger
                              className={`
        h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200 text-black
        ${
          !isEditing
            ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
            : "bg-gray-100 border-black hover:border-gray-700 text-black"
        }
      `}
                            >
                              <SelectValue placeholder={t("Select State")} />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                              {states.map((state) => (
                                <SelectItem
                                  key={state.isoCode}
                                  value={state.name}
                                >
                                  {state.name}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        {/* District Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("District")}{" "}
                            <span className="text-red-500">*</span>
                          </Label>
                          <ReactSelect
                            value={
                              profile["profile.district"]
                                ? {
                                    value: profile["profile.district"],
                                    label: profile["profile.district"],
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              handleProfileFieldChange(
                                "profile.district",
                                selectedOption ? selectedOption.value : ""
                              )
                            }
                            options={districts.map((d) => ({
                              value: d,
                              label: d,
                            }))}
                            placeholder={t("Select District")}
                            isClearable
                            isDisabled={!isEditing || !profile["profile.state"]}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            classNames={{
                              control: (state) => `
          h-10 rounded-l border transition-all duration-200 text-sm text-black
          ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
          ${isEditing ? "bg-gray-100 border-black" : "bg-gray-100 border-none"}
        `,
                              option: (state) => `
          text-sm px-3 py-2 cursor-pointer rounded-lg
          ${
            state.isSelected
              ? "bg-red-500 text-white"
              : state.isFocused
              ? "bg-red-50 text-red-700"
              : "text-gray-900"
          }
        `,
                              menu: () => "rounded-l  shadow-lg mt-1",
                              menuList: () => "py-1",
                              placeholder: () => "text-gray-400",
                              singleValue: () =>
                                `${
                                  !isEditing ? "text-gray-600" : "text-black"
                                }`,
                              indicatorSeparator: () => "bg-gray-300",
                              dropdownIndicator: () =>
                                "text-gray-400 hover:text-gray-600",
                              clearIndicator: () =>
                                "text-gray-400 hover:text-gray-600",
                            }}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "31px",
                                height: "31px",
                                borderRadius: "8px",
                                boxShadow: "none",
                                // border: !isEditing
                                //   ? "none"
                                //   : "1px solid #000",
                                backgroundColor: "#f5f5f5ff",
                                // "&:hover": {
                                //   borderColor: !isEditing
                                //     ? "none"
                                //     : "#374151",
                                // },
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "31px",
                                padding: "0 12px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: "0",
                                padding: "0",
                                color: !isEditing ? "#6b7280" : "#000000",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "31px",
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? "#999a9dff"
                                  : state.isFocused
                                  ? "#cbcccfff"
                                  : "white",
                                color: state.isSelected
                                  ? "white"
                                  : state.isFocused
                                  ? "#363636ff"
                                  : "#0f0f0fff",
                                "&:active": {
                                  backgroundColor: state.isSelected
                                    ? "#bcbdc0ff"
                                    : "#9a9fa8ff",
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: "8px",
                                border: "1px solid #e5e7eb",
                                boxShadow:
                                  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                overflow: "hidden",
                              }),
                            }}
                          />
                          {errors["profile.district"] && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors["profile.district"]}
                            </p>
                          )}
                        </div>

                        {/* Marital Status Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("Marital Status")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <Select
                            value={profile["profile.maritalStatus"] || ""}
                            disabled={!isEditing}
                            onValueChange={(value) =>
                              handleProfileFieldChange(
                                "profile.maritalStatus",
                                value
                              )
                            }
                          >
                            <SelectTrigger
                              className={`
          h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200 text-black
          ${
            errors["profile.maritalStatus"]
              ? "border-red-500 ring-2 ring-red-200"
              : ""
          }
          ${
            !isEditing
              ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700 text-black"
          }
        `}
                            >
                              <SelectValue
                                placeholder={t("Select Marital Status")}
                              />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                              <SelectItem value="Single">
                                {t("Single")}
                              </SelectItem>
                              <SelectItem value="Divorced">
                                {t("Divorced")}
                              </SelectItem>
                              <SelectItem value="Widowed">
                                {t("Widowed")}
                              </SelectItem>
                            </SelectContent>
                          </Select>
                          {errors["profile.maritalStatus"] && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors["profile.maritalStatus"]}
                            </p>
                          )}
                        </div>

                        {/* Conditional Children Input - UPDATED */}
                        {(profile["profile.maritalStatus"] === "Divorced" ||
                          profile["profile.maritalStatus"] === "Widowed") && (
                          <div className="space-y-2">
                            <Label
                              htmlFor="profile.child"
                              className="text-sm font-semibold text-gray-700"
                            >
                              {t("Children")}
                            </Label>
                            <Input
                              id="profile.child"
                              type="number"
                              placeholder={t("Number of children")}
                              value={profile["profile.child_count"] || ""}
                              onChange={(e) =>
                                handleProfileFieldChange(
                                  "profile.child_count",
                                  e.target.value
                                )
                              }
                              className={`
          h-9 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200 text-black
          ${
            !isEditing
              ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700 text-black"
          }
        `}
                              min="0"
                            />
                          </div>
                        )}
                        {errors["profile.child_count"] && (
                          <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                            {errors["profile.child_count"]}
                          </p>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </TabsContent>

                {/* Photos Tab (Professional Info) */}
                <TabsContent
                  value="photos"
                  className="space-y-6  cursor-pointer"
                >
                  <Card>
                    <CardHeader>
                      <CardTitle>{t("Personal")} </CardTitle>
                      <CardDescription>
                        {t("Set your personal informations for better search")}
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {isEditing && professional["gallery"].length < 6 && (
                          <>
                            {cropImage && (
                              <>
                                <div className="fixed inset-0 bg-black/40 backdrop-blur-md z-40"></div>
                                <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
                                  <div className="bg-white rounded-xl shadow-2xl w-[90%] max-w-md max-h-[40vh] flex flex-col">
                                    <div className="p-3 border-b border-gray-100 flex justify-between items-center flex-shrink-0">
                                      <div>
                                        <h3 className="font-semibold text-gray-900 text-md">
                                          {t("Crop Image")}{" "}
                                          {currentCropIndex + 1} of{" "}
                                          {filesToCrop.length}
                                        </h3>
                                        <p className="text-xs text-gray-600 mt-1">
                                          {t("Adjust the crop area")} (
                                          {professional["gallery"].length +
                                            currentCropIndex +
                                            1}
                                          /6)
                                        </p>
                                      </div>
                                      <button
                                        onClick={() => {
                                          setCropImage(null);
                                          setCrop(undefined);
                                          setCompletedCrop(undefined);
                                          setFilesToCrop([]);
                                          setCurrentCropIndex(0);
                                          setGalleryCropAspect(
                                            GALLERY_DEFAULT_ASPECT
                                          );
                                        }}
                                        className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1 rounded-full transition-colors cursor-pointer"
                                      >
                                        <X className="w-5 h-5" />
                                      </button>
                                    </div>

                                    <div className="flex items-center justify-center gap-2 px-3 pt-2 flex-shrink-0">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setGalleryCropAspect(
                                            GALLERY_DEFAULT_ASPECT
                                          );
                                          if (imgRef.current) {
                                            const { width, height } =
                                              imgRef.current;
                                            setCrop(
                                              centerAspectCrop(
                                                width,
                                                height,
                                                GALLERY_DEFAULT_ASPECT
                                              )
                                            );
                                          }
                                        }}
                                        className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium border transition-colors cursor-pointer ${
                                          galleryCropAspect ===
                                          GALLERY_DEFAULT_ASPECT
                                            ? "bg-red-500 text-white border-red-500"
                                            : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                                        }`}
                                      >
                                        <Square className="w-3 h-3" />
                                        {t("Classic")}
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setGalleryCropAspect(undefined);
                                          setCrop(getFullImageCrop());
                                        }}
                                        className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium border transition-colors cursor-pointer ${
                                          galleryCropAspect === undefined
                                            ? "bg-red-500 text-white border-red-500"
                                            : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100"
                                        }`}
                                      >
                                        <Crop className="w-3 h-3" />
                                        {t("Full Image")}
                                      </button>
                                    </div>

                                    <div className="flex-1 overflow-auto p-3">
                                      <div className="flex justify-center items-center h-full">
                                        {cropImage && (
                                          <div className="max-w-full max-h-[20vh]">
                                            <ReactCrop
                                              crop={crop}
                                              onChange={(_, percentCrop) =>
                                                setCrop(percentCrop)
                                              }
                                              onComplete={(c) =>
                                                setCompletedCrop(c)
                                              }
                                              aspect={galleryCropAspect}
                                            >
                                              <img
                                                ref={imgRef}
                                                alt="Crop"
                                                src={cropImage}
                                                className="max-h-[18vh] max-w-full object-contain"
                                                onLoad={(e) => {
                                                  const { width, height } =
                                                    e.currentTarget;
                                                  setCrop(
                                                    galleryCropAspect
                                                      ? centerAspectCrop(
                                                          width,
                                                          height,
                                                          galleryCropAspect
                                                        )
                                                      : getFullImageCrop()
                                                  );
                                                }}
                                              />
                                            </ReactCrop>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="p-3 border-t border-gray-100 bg-gray-50 flex gap-2 flex-shrink-0">
                                      <button
                                        onClick={() => {
                                          setCropImage(null);
                                          setCrop(undefined);
                                          setCompletedCrop(undefined);
                                          setFilesToCrop([]);
                                          setCurrentCropIndex(0);
                                          setGalleryCropAspect(
                                            GALLERY_DEFAULT_ASPECT
                                          );
                                        }}
                                        className="flex-1 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100 font-medium transition-colors text-sm cursor-pointer"
                                      >
                                        {t("Cancel All")}
                                      </button>

                                      {currentCropIndex <
                                      filesToCrop.length - 1 ? (
                                        <button
                                          onClick={async () => {
                                            await handleCropAndUpload(
                                              filesToCrop[currentCropIndex],
                                              currentCropIndex
                                            );
                                            const nextIndex =
                                              currentCropIndex + 1;
                                            setCurrentCropIndex(nextIndex);
                                            const nextFile =
                                              filesToCrop[nextIndex];
                                            const nextImageUrl =
                                              URL.createObjectURL(nextFile);
                                            setCropImage(nextImageUrl);
                                            setCrop(undefined);
                                            setCompletedCrop(undefined);
                                            setGalleryCropAspect(
                                              GALLERY_DEFAULT_ASPECT
                                            );
                                          }}
                                          disabled={!completedCrop}
                                          className="flex-1 py-2 bg-gradient-to-br from-red-500 to-pink-600 text-white rounded  disabled:bg-gray-400 disabled:cursor-not-allowed font-medium transition-colors text-sm cursor-pointer"
                                        >
                                          {t("Save & Next")} (
                                          {currentCropIndex + 1}/
                                          {filesToCrop.length})
                                        </button>
                                      ) : (
                                        <button
                                          onClick={async () => {
                                            await handleCropAndUpload(
                                              filesToCrop[currentCropIndex],
                                              currentCropIndex
                                            );
                                            setCropImage(null);
                                            setCrop(undefined);
                                            setCompletedCrop(undefined);
                                            setFilesToCrop([]);
                                            setCurrentCropIndex(0);
                                            setGalleryCropAspect(
                                              GALLERY_DEFAULT_ASPECT
                                            );
                                          }}
                                          disabled={!completedCrop}
                                          className="flex-1 py-2 bg-gradient-to-br from-red-500 to-pink-600 text-white rounded  disabled:bg-gray-400 disabled:cursor-not-allowed font-medium transition-colors text-sm cursor-pointer"
                                        >
                                          {t("Save & Upload All")} (
                                          {filesToCrop.length})
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {/* <AlertDialog
                              open={!!cropImage}
                              onOpenChange={() => {
                                setCropImage(null);
                                setCrop(undefined);
                                setCompletedCrop(undefined);
                                setFilesToCrop([]);
                                setCurrentCropIndex(0);
                              }}
                            >
                              <AlertDialogContent className="max-w-md w-[90%] p-0 overflow-hidden">
                                
                                <div className="p-4 border-b border-gray-200">
                                  <AlertDialogHeader>
                                    <AlertDialogTitle className="text-lg font-semibold text-gray-900">
                                      {t("Crop Image")} {currentCropIndex + 1} /{" "}
                                      {filesToCrop.length}
                                    </AlertDialogTitle>

                                    <AlertDialogDescription className="text-gray-600 mt-1 text-sm">
                                      {t("Adjust the crop area")} (
                                      {professional["gallery"].length +
                                        currentCropIndex +
                                        1}
                                      /6 )
                                    </AlertDialogDescription>
                                  </AlertDialogHeader>
                                </div>

                               
                                <div className="p-4 max-h-[40vh] overflow-auto flex justify-center items-center">
                                  {cropImage && (
                                    <div className="max-w-full max-h-[30vh]">
                                      <ReactCrop
                                        crop={crop}
                                        onChange={(_, percentCrop) =>
                                          setCrop(percentCrop)
                                        }
                                        onComplete={(c) => setCompletedCrop(c)}
                                        aspect={4 / 3}
                                      >
                                        <img
                                          ref={imgRef}
                                          alt="Crop"
                                          src={cropImage}
                                          className="max-h-[28vh] max-w-full object-contain"
                                          onLoad={(e) => {
                                            const { width, height } =
                                              e.currentTarget;
                                            setCrop(
                                              centerAspectCrop(
                                                width,
                                                height,
                                                4 / 3
                                              )
                                            );
                                          }}
                                        />
                                      </ReactCrop>
                                    </div>
                                  )}
                                </div>

                                
                                <div className="p-4 bg-gray-50 border-t border-gray-200 flex gap-3">
                                 
                                  <AlertDialogCancel
                                    onClick={() => {
                                      setCropImage(null);
                                      setCrop(undefined);
                                      setCompletedCrop(undefined);
                                      setFilesToCrop([]);
                                      setCurrentCropIndex(0);
                                    }}
                                    className="flex-1 py-2 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-100 text-sm"
                                  >
                                    {t("Cancel All")}
                                  </AlertDialogCancel>

                               
                                  {currentCropIndex < filesToCrop.length -1? (
                                    <AlertDialogAction
                                      disabled={!completedCrop}
                                      onClick={async () => {
                                        await handleCropAndUpload(
                                          filesToCrop[currentCropIndex],
                                          currentCropIndex
                                        );

                                        const nextIndex = currentCropIndex + 1;
                                        setCurrentCropIndex(nextIndex);

                                        const nextFile = filesToCrop[nextIndex];
                                        const nextImageUrl =
                                          URL.createObjectURL(nextFile);

                                        setCropImage(nextImageUrl);
                                        setCrop(undefined);
                                        setCompletedCrop(undefined);
                                      }}
                                      className="flex-1 py-2 bg-gradient-to-br from-red-500 to-pink-600 text-white rounded-lg disabled:bg-gray-400 text-sm"
                                    >
                                      {t("Save & Next")} ({currentCropIndex + 1}
                                      /{filesToCrop.length})
                                    </AlertDialogAction>
                                  ) : (
                                    <AlertDialogAction
                                      disabled={!completedCrop}
                                      onClick={async () => {
                                        await handleCropAndUpload(
                                          filesToCrop[currentCropIndex],
                                          currentCropIndex
                                        );
                                        setCropImage(null);
                                        setCrop(undefined);
                                        setCompletedCrop(undefined);
                                        setFilesToCrop([]);
                                        setCurrentCropIndex(0);
                                      }}
                                      className="flex-1 py-2 bg-gradient-to-br from-red-500 to-pink-600 text-white rounded-lg disabled:bg-gray-400 text-sm"
                                    >
                                      {t("Save & Upload All")} (
                                      {filesToCrop.length})
                                    </AlertDialogAction>
                                  )}
                                </div>
                              </AlertDialogContent>
                            </AlertDialog> */}

                            {showMultiPreview && (
                              <>
                                <div className="fixed inset-0 bg-black/40 backdrop-blur-md z-40"></div>
                                <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
                                  <div className="bg-white rounded-xl shadow-2xl w-[90%] max-w-3xl h-[80vh] flex flex-col">
                                    <div className="p-6 border-b border-gray-100 flex justify-between items-center flex-shrink-0">
                                      <div>
                                        <h3 className="font-semibold text-gray-900 text-lg">
                                          {t("Confirm Upload")} (
                                          {selectedFiles.length} {t("images")})
                                        </h3>
                                        <p className="text-sm text-gray-600 mt-1">
                                          {t(
                                            "Review your selected images before uploading"
                                          )}
                                        </p>
                                      </div>
                                      <button
                                        onClick={() => {
                                          setShowMultiPreview(false);
                                          setSelectedFiles([]);
                                        }}
                                        className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-2 rounded-full transition-colors cursor-pointer"
                                      >
                                        <X className="w-6 h-6" />
                                      </button>
                                    </div>
                                    <div className="flex-1 overflow-y-auto p-6">
                                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                        {6 -
                                          (professional["gallery"].length +
                                            selectedFiles.length) >
                                        0 ? (
                                          <div
                                            className="border-2 border-dashed border-gray-300 rounded-lg p-2 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50/30 transition-all duration-300 bg-gradient-to-br from-white to-gray-50/50 aspect-square"
                                            onClick={() =>
                                              document
                                                .getElementById(
                                                  "gallery-upload"
                                                )
                                                .click()
                                            }
                                          >
                                            <div className="text-center space-y-2 cursor-pointer">
                                              <Plus className="w-8 h-8 mx-auto text-gray-400" />
                                              <p className="text-sm font-medium text-gray-600">
                                                {t("Add More")}
                                              </p>
                                              <p className="text-xs text-gray-500">
                                                {6 -
                                                  (professional["gallery"]
                                                    .length +
                                                    selectedFiles.length)}{" "}
                                                {t("remaining")}
                                              </p>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}

                                        {selectedFiles.map((file, index) => (
                                          <div
                                            key={index}
                                            className="relative bg-gray-50 rounded-lg p-2"
                                          >
                                            <div className="relative aspect-square">
                                              <img
                                                src={URL.createObjectURL(file)}
                                                alt={`Preview ${index + 1}`}
                                                className="w-full h-full object-contain bg-gray-100 rounded-md"
                                              />
                                              <button
                                                onClick={() => {
                                                  setSelectedFiles((prev) =>
                                                    prev.filter(
                                                      (_, i) => i !== index
                                                    )
                                                  );
                                                }}
                                                className="relative -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-90 hover:opacity-100 transition-opacity border-2 border-white cursor-pointer"
                                                style={{
                                                  position: "relative",
                                                  bottom: "10px",
                                                  right: "10px",
                                                }}
                                              >
                                                <X className="w-3 h-3" />
                                              </button>
                                            </div>
                                            <p className="text-xs text-gray-600 mt-2 truncate px-1">
                                              {file.name}
                                            </p>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="p-6 border-t border-gray-100 bg-gray-50 flex gap-3 flex-shrink-0">
                                      <button
                                        onClick={() => {
                                          setShowMultiPreview(false);
                                          setSelectedFiles([]);
                                        }}
                                        className="flex-1 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 font-medium transition-colors cursor-pointer"
                                      >
                                        {t("Cancel All")}
                                      </button>
                                      <button
                                        onClick={async () => {
                                          setShowMultiPreview(false);
                                          if (selectedFiles.length > 0) {
                                            const firstFile = selectedFiles[0];
                                            const imageUrl =
                                              URL.createObjectURL(firstFile);
                                            setGalleryCropAspect(
                                              GALLERY_DEFAULT_ASPECT
                                            );
                                            setCropImage(imageUrl);

                                            setFilesToCrop(selectedFiles);
                                          }
                                          setSelectedFiles([]);
                                        }}
                                        disabled={selectedFiles.length === 0}
                                        className="flex-1 py-3 bg-gradient-to-br from-red-500 to-pink-600 text-white rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed font-medium transition-colors cursor-pointer"
                                      >
                                        {selectedFiles.length === 0
                                          ? t("No Images Selected")
                                          : `${t("Start Cropping")} (${
                                              selectedFiles.length
                                            } ${t("images")})`}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* Upload Trigger - Multiple Files */}
                            <input
                              type="file"
                              id="gallery-upload"
                              accept="image/*"
                              multiple
                              className="hidden"
                              onChange={async (e) => {
                                try {
                                  const files = Array.from(e.target.files);
                                  if (!files.length) return;

                                  const totalAfterUpload =
                                    professional["gallery"].length +
                                    selectedFiles.length +
                                    files.length;
                                  if (totalAfterUpload > 6) {
                                    toast.error(
                                      `You can only upload ${
                                        6 -
                                        (professional["gallery"].length +
                                          selectedFiles.length)
                                      } more images`
                                    );
                                    return;
                                  }

                                  // Validate all files first
                                  const validFiles = [];
                                  for (const file of files) {
                                    if (file.size > 5 * 1024 * 1024) {
                                      toast.error(
                                        `${file.name} is too large (max 5MB)`
                                      );
                                      continue;
                                    }
                                    if (!file.type.startsWith("image/")) {
                                      toast.error(
                                        `${file.name} is not a valid image file`
                                      );
                                      continue;
                                    }
                                    validFiles.push(file);
                                  }

                                  if (validFiles.length > 0) {
                                    // Add to existing selected files
                                    setSelectedFiles((prev) => [
                                      ...prev,
                                      ...validFiles,
                                    ]);
                                    // Keep multi-preview open
                                    setShowMultiPreview(true);
                                  }
                                } catch (error) {
                                  toast.error("Failed to select images");
                                } finally {
                                  e.target.value = "";
                                }
                              }}
                            />

                            {/* Upload Box */}
                            <div
                              className="group border-2 border-dashed border-gray-300 rounded-2xl h-48 flex items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50/30 transition-all duration-300 bg-gradient-to-br from-white to-gray-50/50"
                              onClick={() =>
                                document
                                  .getElementById("gallery-upload")
                                  .click()
                              }
                            >
                              <div className="text-center space-y-3">
                                <div className="relative">
                                  <Camera className="w-10 h-10 mx-auto text-gray-400 group-hover:text-blue-500 transition-colors duration-300" />
                                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full border-2 border-white"></div>
                                </div>
                                <div>
                                  <p className="text-sm font-semibold text-gray-600 group-hover:text-blue-600 transition-colors duration-300">
                                    {t("Add Gallery Photos")}
                                  </p>
                                  <p className="text-xs text-gray-500 group-hover:text-blue-500 transition-colors duration-300 mt-1">
                                    {t("Upload")}{" "}
                                    {6 - professional["gallery"].length}{" "}
                                    {t(
                                      "more images | Multiple selection available"
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {professional["gallery"] &&
                          professional["gallery"].map((photo, index) => (
                            <div key={index} className="relative group">
                              <ImageWithFallback
                                src={photo}
                                alt={`Profile photo ${index + 1}`}
                                className="w-full h-48 object-contain bg-gray-100 rounded-lg"
                              />

                              {isEditing && (
                                <div className="absolute top-2 right-2 z-10">
                                  <Button
                                    variant="destructive"
                                    size="icon"
                                    className="rounded-full shadow-md hover:scale-110 transition-transform cursor-pointer h-6 w-6 p-1"
                                    onClick={async () => {
                                      try {
                                        const response =
                                          await deleteWithTokenAPI(
                                            token,
                                            `/document/delete/${professional["documentId"][index]}`
                                          );

                                        if (response?.statusCode === 200) {
                                          toast.success(
                                            `${t(
                                              "Image deleted successfully!"
                                            )}`
                                          );
                                          setProfessional((prev) => ({
                                            ...prev,
                                            gallery: prev.gallery.filter(
                                              (_, i) => i !== index
                                            ),
                                            documentId: prev.documentId.filter(
                                              (_, i) => i !== index
                                            ),
                                          }));
                                        } else {
                                          toast.error(
                                            `${t(
                                              "Failed to delete image from server."
                                            )}`
                                          );
                                        }
                                      } catch (error) {
                                        toast.error(
                                          `${t(
                                            "Something went wrong while deleting!"
                                          )}`
                                        );
                                      }
                                    }}
                                  >
                                    <X className="w-3 h-3" />
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
                        {(profile["profile.caste"] === "No Caste Barrier"
                          ? [
                              ["father_name", "Father Name"],
                              ["mother_name", "Mother Name"],
                              ["instagram", "Instagram Profile"],
                              ["profession", "Profession"],
                              ["income", "Income"],
                              ["height", "Height(cm)"],
                              ["weight", "Weight (kg)"],
                              ["motherTongue", "Mother Tongue"],
                            ]
                          : [
                              ["father_name", "Father Name"],
                              ["mother_name", "Mother Name"],
                              ["instagram", "Instagram Profile"],
                              ["profession", "Profession"],
                              ["income", "Income"],
                              ["height", "Height(cm)"],
                              ["weight", "Weight (kg)"],
                              ["motherTongue", "Mother Tongue"],
                              ["subCaste", "Sub Caste"],
                            ]
                        ).map(([id, label]) => {
                          const isMandatory =
                            label === "Height(cm)" || label === "Mother Tongue";
                          return (
                            <div key={id} className="space-y-1">
                              <Label
                                htmlFor={id}
                                className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                              >
                                {t(label)}
                                {isMandatory && (
                                  <span className="text-red-500">*</span>
                                )}
                              </Label>
                              <Input
                                id={id}
                                value={professional[id] || ""}
                                disabled={!isEditing}
                                onChange={(e) =>
                                  setProfessional({
                                    ...professional,
                                    [id]: e.target.value,
                                  })
                                }
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 placeholder:text-gray-400 text-black
            ${errors[id] ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              />
                              {errors[id] && (
                                <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                  {errors[id]}
                                </p>
                              )}
                            </div>
                          );
                        })}

                        {/* Education Dropdown - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("Education")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <ReactSelect
                            value={
                              professional["education"]
                                ? {
                                    value: professional["education"],
                                    label: t(professional["education"]),
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              setProfessional({
                                ...professional,
                                education: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            options={educationOptions}
                            placeholder={t("Select Education")}
                            isClearable
                            isDisabled={!isEditing}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            classNames={{
                              control: (state) => `
          h-10 rounded-l border transition-all duration-200 text-sm text-black
          ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
          ${errors.education ? "border-red-500 ring-2 ring-red-200" : ""}
          ${
            !isEditing
              ? "bg-gray-100 border-none cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700"
          }
        `,
                              option: (state) => `
          text-sm px-3 py-2 cursor-pointer rounded-lg
          ${
            state.isSelected
              ? "bg-red-500 text-white"
              : state.isFocused
              ? "bg-red-50 text-red-700"
              : "text-gray-900"
          }
        `,
                              menu: () =>
                                "rounded-l border border-gray-200 shadow-lg mt-1",
                              menuList: () => "py-1",
                              placeholder: () => "text-gray-400",
                              singleValue: () =>
                                `${
                                  !isEditing ? "text-gray-600" : "text-black"
                                }`,
                              indicatorSeparator: () => "bg-gray-300",
                              dropdownIndicator: () =>
                                "text-gray-400 hover:text-gray-600",
                              clearIndicator: () =>
                                "text-gray-400 hover:text-gray-600",
                            }}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: "35px",
                                height: "35px",
                                borderRadius: "8px",
                                boxShadow: "none",
                                // border: !isEditing
                                //   ? "none"
                                //   : "1px solid #000",
                                backgroundColor: "#f5f5f5ff",
                                // "&:hover": {
                                //   borderColor: !isEditing
                                //     ? "none"
                                //     : "#374151",
                                // },
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                height: "35px",
                                padding: "0 12px",
                              }),
                              input: (base) => ({
                                ...base,
                                margin: "0",
                                padding: "0",
                                color: !isEditing ? "#6b7280" : "#000000",
                              }),
                              indicatorsContainer: (base) => ({
                                ...base,
                                height: "35px",
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? "#999a9dff"
                                  : state.isFocused
                                  ? "#cbcccfff"
                                  : "white",
                                color: state.isSelected
                                  ? "white"
                                  : state.isFocused
                                  ? "#363636ff"
                                  : "#0f0f0fff",
                                "&:active": {
                                  backgroundColor: state.isSelected
                                    ? "#bcbdc0ff"
                                    : "#9a9fa8ff",
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: "8px",
                                border: "1px solid #e5e7eb",
                                boxShadow:
                                  "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                overflow: "hidden",
                              }),
                            }}
                          />
                          {errors.education && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors.education}
                            </p>
                          )}
                        </div>

                        {/* Diet Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                            {t("Diet")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <Select
                            value={professional["diet"] || ""}
                            disabled={!isEditing}
                            onValueChange={(value) =>
                              setProfessional({
                                ...professional,
                                diet: value,
                              })
                            }
                          >
                            <SelectTrigger
                              className={`
          h-14 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200 text-black
          ${errors.diet ? "border-red-500 ring-2 ring-red-200" : ""}
          ${
            !isEditing
              ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700 text-black"
          }
        `}
                            >
                              <SelectValue placeholder={t("Select Diet")} />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                              <SelectItem
                                value="Vegetarian"
                                className="rounded-lg"
                              >
                                {t("Vegetarian")}
                              </SelectItem>
                              <SelectItem
                                value="Non-Vegetarian"
                                className="rounded-lg"
                              >
                                {t("Non-Vegetarian")}
                              </SelectItem>
                              <SelectItem
                                value="Eggetarian"
                                className="rounded-lg"
                              >
                                {t("Eggetarian")}
                              </SelectItem>
                            </SelectContent>
                          </Select>
                          {errors.diet && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors.diet}
                            </p>
                          )}
                        </div>

                        <div className="space-y-2">
                          <Label
                            htmlFor="siblings"
                            className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                          >
                            {t("Siblings")}
                            <span className="text-red-500">*</span>
                          </Label>
                          <Textarea
                            id="siblings"
                            value={professional.siblings || ""}
                            disabled={!isEditing}
                            rows={2}
                            onChange={(e) =>
                              setProfessional({
                                ...professional,
                                siblings: e.target.value,
                              })
                            }
                            className={`
        rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200 placeholder:text-gray-400 text-black
        ${errors.siblings ? "border-red-500 ring-2 ring-red-200" : ""}
        ${
          !isEditing
            ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
            : "bg-gray-100 border-black hover:border-gray-700 text-black"
        }
      `}
                          />
                          {errors.siblings && (
                            <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                              {errors.siblings}
                            </p>
                          )}
                        </div>

                        {/* Additional Fields - UPDATED */}
                        {[
                          ["rasi", "Rasi"],
                          ["natchathiram", "Natchathiram"],
                          ["gothram", "Gothram"],
                          ["laknam", "Laknam"],
                        ].map(([id, label]) => {
                          return (
                            <div key={id} className="space-y-2">
                              <Label
                                htmlFor={id}
                                className="text-sm font-semibold text-gray-700"
                              >
                                {t(label)}
                              </Label>
                              <Input
                                id={id}
                                value={professional[id] || ""}
                                disabled={!isEditing}
                                onChange={(e) =>
                                  setProfessional({
                                    ...professional,
                                    [id]: e.target.value,
                                  })
                                }
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              />
                            </div>
                          );
                        })}

                        {/* Dosham Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700">
                            {t("Dosham")}
                          </Label>
                          <Select
                            value={professional["dosham"] || ""}
                            disabled={!isEditing}
                            onValueChange={(value) =>
                              setProfessional({
                                ...professional,
                                dosham: value,
                              })
                            }
                          >
                            <SelectTrigger
                              className={`
        h-12 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200 text-black
        ${
          !isEditing
            ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
            : "bg-gray-100 border-black hover:border-gray-700 text-black"
        }
      `}
                            >
                              <SelectValue placeholder={t("Select Dosham")} />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                              <SelectItem value="Yes" className="rounded-lg">
                                {t("Yes")}
                              </SelectItem>
                              <SelectItem value="No" className="rounded-lg">
                                {t("No")}
                              </SelectItem>
                              <SelectItem
                                value="Don't Know"
                                className="rounded-lg"
                              >
                                {t("Don't Know")}
                              </SelectItem>
                            </SelectContent>
                          </Select>
                        </div>

                        {/* Kuja Dosham Field - UPDATED */}
                        <div className="space-y-2">
                          <Label className="text-sm font-semibold text-gray-700">
                            {t("Kuja Dosham")}
                          </Label>
                          <Select
                            value={professional.kujaDosham || ""}
                            disabled={!isEditing}
                            onValueChange={(value) =>
                              setProfessional({
                                ...professional,
                                kujaDosham: value,
                              })
                            }
                          >
                            <SelectTrigger
                              className={`
        h-12 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
        transition-all duration-200 text-black
        ${
          !isEditing
            ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
            : "bg-gray-100 border-black hover:border-gray-700 text-black"
        }
      `}
                            >
                              <SelectValue
                                placeholder={t("Select Kuja Dosham")}
                              />
                            </SelectTrigger>
                            <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                              <SelectItem value="Yes" className="rounded-lg">
                                {t("Yes")}
                              </SelectItem>
                              <SelectItem value="No" className="rounded-lg">
                                {t("No")}
                              </SelectItem>
                              <SelectItem
                                value="Don't Know"
                                className="rounded-lg"
                              >
                                {t("Don't Know")}
                              </SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      </div>

                      <div className="space-y-2 mt-4">
                        <Label
                          htmlFor="property_details"
                          className="text-sm font-semibold text-gray-700"
                        >
                          {t("Property Deeds")}
                        </Label>
                        <Textarea
                          id="property_details"
                          value={professional.property_details || ""}
                          disabled={!isEditing}
                          rows={2}
                          onChange={(e) =>
                            setProfessional({
                              ...professional,
                              property_details: e.target.value,
                            })
                          }
                          className={`
      rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
      transition-all duration-200 placeholder:text-gray-400 text-black
      ${
        !isEditing
          ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
          : "bg-gray-100 border-black hover:border-gray-700 text-black"
      }
    `}
                        />
                      </div>

                      {/* About Me Section - UPDATED */}
                      <div className="space-y-2 mt-8">
                        <Label
                          htmlFor="about"
                          className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                        >
                          {t("About Me")}
                          <span className="text-red-500">*</span>
                        </Label>
                        <Textarea
                          id="about"
                          value={professional.aboutMe || ""}
                          disabled={!isEditing}
                          rows={4}
                          onChange={(e) =>
                            setProfessional({
                              ...professional,
                              aboutMe: e.target.value,
                            })
                          }
                          className={`
      rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
      transition-all duration-200 placeholder:text-gray-400 text-black
      ${errors.aboutMe ? "border-red-500 ring-2 ring-red-200" : ""}
      ${
        !isEditing
          ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
          : "bg-gray-100 border-black hover:border-gray-700 text-black"
      }
    `}
                        />
                        {errors.aboutMe && (
                          <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                            {errors.aboutMe}
                          </p>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </TabsContent>

                {/* Preferences Tab */}
                <TabsContent
                  value="preferences"
                  className="space-y-6  cursor-pointer"
                >
                  <Card>
                    <CardHeader>
                      <CardTitle>{t("Partner Preferences")}</CardTitle>
                      <CardDescription>
                        {t("Set your preferences for potential matches")}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      <CardContent className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {[
                            ["min_age", "Min age"],
                            ["max_age", "Max age"],
                            ["min", "Min Height(cm)"],
                            ["max", "Max Height(cm)"],
                            ["mother_tongue", "Mother Tongue"],
                            ["about_partner", "About"],
                          ].map(([id, label]) => {
                            const isMandatory =
                              label === "Min Height(cm)" ||
                              label === "Max Height(cm)" ||
                              label === "Mother Tongue" ||
                              label === "About";
                            return (
                              <div key={id} className="space-y-2">
                                <Label
                                  htmlFor={id}
                                  className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                                >
                                  {t(label)}
                                  {isMandatory && (
                                    <span className="text-red-500">*</span>
                                  )}
                                </Label>
                                <Input
                                  id={id}
                                  value={preference[id] || ""}
                                  disabled={!isEditing}
                                  onChange={(e) =>
                                    setPreference({
                                      ...preference,
                                      [id]: e.target.value,
                                    })
                                  }
                                  className={`
              h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
              transition-all duration-200 placeholder:text-gray-400 text-black
              ${errors[id] ? "border-red-500 ring-2 ring-red-200" : ""}
              ${
                !isEditing
                  ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                  : "bg-gray-100 border-black hover:border-gray-700 text-black"
              }
            `}
                                />
                                {errors[id] && (
                                  <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                    {errors[id]}
                                  </p>
                                )}
                              </div>
                            );
                          })}

                          {/* Gender Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Gender")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <Select
                              value={preference["gender"] || ""}
                              disabled={!isEditing}
                              onValueChange={(value) =>
                                setPreference({
                                  ...preference,
                                  gender: value,
                                })
                              }
                            >
                              <SelectTrigger
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${errors.gender ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              >
                                <SelectValue placeholder={t("Select gender")} />
                              </SelectTrigger>
                              <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                                <SelectItem value="Male" className="rounded-lg">
                                  {t("Male")}
                                </SelectItem>
                                <SelectItem
                                  value="Female"
                                  className="rounded-lg"
                                >
                                  {t("Female")}
                                </SelectItem>
                                <SelectItem
                                  value="Other"
                                  className="rounded-lg"
                                >
                                  {t("Other")}
                                </SelectItem>
                              </SelectContent>
                            </Select>
                            {errors.gender && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.gender}
                              </p>
                            )}
                          </div>

                          {/* Religion Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Religion")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <ReactSelect
                              value={
                                Array.isArray(preference["religion"])
                                  ? preference["religion"]
                                      .map((religionValue) => ({
                                        value: religionValue, // English value
                                        label: t(religionValue), // Tamil translation for display
                                      }))
                                      .filter(Boolean)
                                  : preference["religion"]
                                  ? [
                                      {
                                        value: preference["religion"],
                                        label: t(preference["religion"]), // Tamil translation for display
                                      },
                                    ].filter(Boolean)
                                  : []
                              }
                              onChange={(selectedOptions) => {
                                const selectedValues = selectedOptions
                                  ? selectedOptions.map(
                                      (option) => option.value
                                    ) // Extract English values
                                  : [];

                                setPreference({
                                  ...preference,
                                  religion: selectedValues,
                                });
                              }}
                              options={religionOptions.map((option) => ({
                                value: option.value, // English value for API
                                label: t(option.value), // Tamil translation for display
                              }))}
                              placeholder={t("Select Religion")}
                              isMulti
                              isClearable
                              isDisabled={!isEditing}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              classNames={{
                                control: (state) => `
        h-10 rounded-l border transition-all duration-200 text-sm text-black
        ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
        ${errors.religion ? "border-red-500 ring-2 ring-red-200" : ""}
        ${
          !isEditing
            ? "bg-gray-100 border-none cursor-not-allowed"
            : "bg-gray-100 border-black hover:border-gray-700"
        }
      `,
                                option: (state) => `
        text-sm px-3 py-2 cursor-pointer rounded-lg
        ${
          state.isSelected
            ? "bg-red-500 text-white"
            : state.isFocused
            ? "bg-red-50 text-red-700"
            : "text-gray-900"
        }
      `,
                                menu: () =>
                                  "rounded-l border border-gray-200 shadow-lg mt-1",
                                menuList: () => "py-1",
                                placeholder: () => "text-gray-400",
                                multiValue: () =>
                                  "bg-gray-200 rounded px-2 text-sm",
                                multiValueLabel: () => "text-gray-900 text-sm",
                                multiValueRemove: () =>
                                  "text-gray-500 hover:text-gray-700",
                                input: () => "text-sm",
                                singleValue: () =>
                                  `${
                                    !isEditing ? "text-gray-600" : "text-black"
                                  }`,
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "31px",
                                  height: "31px",
                                  borderRadius: "8px",
                                  boxShadow: "none",
                                  // border: !isEditing
                                  //   ? "none"
                                  //   : "1px solid #000",
                                  backgroundColor: "#f5f5f5ff",
                                  // "&:hover": {
                                  //   borderColor: !isEditing
                                  //     ? "none"
                                  //     : "#374151",
                                  // },
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                  padding: "0 12px",
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: "0",
                                  padding: "0",
                                  color: !isEditing ? "#6b7280" : "#000000",
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#999a9dff"
                                    : state.isFocused
                                    ? "#cbcccfff"
                                    : "white",
                                  color: state.isSelected
                                    ? "white"
                                    : state.isFocused
                                    ? "#363636ff"
                                    : "#0f0f0fff",
                                  "&:active": {
                                    backgroundColor: state.isSelected
                                      ? "#bcbdc0ff"
                                      : "#9a9fa8ff",
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: "8px",
                                  border: "1px solid #e5e7eb",
                                  boxShadow:
                                    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                  overflow: "hidden",
                                }),
                              }}
                            />
                            {errors.religion && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.religion}
                              </p>
                            )}
                          </div>

                          {/* Caste Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Caste")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <ReactSelect
                              value={
                                Array.isArray(preference["caste"])
                                  ? preference["caste"].map((caste) => ({
                                      value: caste,
                                      label: t(caste),
                                    }))
                                  : preference["caste"]
                                  ? [
                                      {
                                        value: preference["caste"],
                                        label: t(preference["caste"]),
                                      },
                                    ]
                                  : []
                              }
                              onChange={(selectedOptions) =>
                                setPreference({
                                  ...preference,
                                  caste: selectedOptions
                                    ? selectedOptions.map(
                                        (option) => option.value
                                      )
                                    : [],
                                })
                              }
                              options={[
                                { value: "Nadar", label: t("Nadar") },
                                { value: "Pillai", label: t("Pillai") },
                                { value: "Naidu", label: t("Naidu") },
                                {
                                  value: "Ilathu Pillai",
                                  label: t("Ilathu Pillai"),
                                },
                                {
                                  value: "Vishwakarma",
                                  label: t("Vishwakarma"),
                                },
                                {
                                  value: "Saiva Pillai",
                                  label: t("Saiva Pillai"),
                                },
                                { value: "Kallar", label: t("Kallar") },
                                { value: "Maravar", label: t("Maravar") },
                                {
                                  value: "Agamudaiyar",
                                  label: t("Agamudaiyar"),
                                },
                                { value: "Chettiyar", label: t("Chettiyar") },
                                { value: "Christian", label: t("Christian") },
                                { value: "Muslim", label: t("Muslim") },
                                { value: "Maruthuvar", label: t("Maruthuvar") },
                                { value: "Sourashtra", label: t("Sourashtra") },
                                { value: "Vanniyar", label: t("Vanniyar") },
                                { value: "Naicker", label: t("Naicker") },
                                { value: "Muppanar", label: t("Muppanar") },
                                {
                                  value: "Veerasaivam",
                                  label: t("Veerasaivam"),
                                },
                                { value: "Malayali", label: t("Malayali") },
                                { value: "Kulalar", label: t("Kulalar") },
                                { value: "Iyer", label: t("Iyer") },
                                { value: "Iyengar", label: t("Iyengar") },
                                { value: "Mudaliyar", label: t("Mudaliyar") },
                                { value: "Yadavar", label: t("Yadavar") },
                                { value: "Reddy", label: t("Reddy") },
                                { value: "Vannar", label: t("Vannar") },
                                { value: "Doctor", label: t("Doctor") },
                                {
                                  value: "Adi Dravidar",
                                  label: t("Adi Dravidar"),
                                },
                                {
                                  value: "Devendra Kula Vellalar",
                                  label: t("Devendra Kula Vellalar"),
                                },
                                {
                                  value: "Arunthathiyar",
                                  label: t("Arunthathiyar"),
                                },
                                { value: "Kolandar", label: t("Kolandar") },
                                {
                                  value: "No Caste Barrier",
                                  label: t("No Caste Barrier"),
                                },
                              ]}
                              placeholder={t("Select Caste")}
                              isMulti
                              isClearable
                              isDisabled={!isEditing}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              classNames={{
                                control: (state) => `
            h-10 rounded-l border transition-all duration-200 text-sm text-black
            ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
            ${errors.caste ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700"
            }
          `,
                                option: (state) => `
            text-sm px-3 py-2 cursor-pointer rounded-lg
            ${
              state.isSelected
                ? "bg-red-500 text-white"
                : state.isFocused
                ? "bg-red-50 text-red-700"
                : "text-gray-900"
            }
          `,
                                menu: () =>
                                  "rounded-l border border-gray-200 shadow-lg mt-1",
                                menuList: () => "py-1",
                                placeholder: () => "text-gray-400",
                                multiValue: () =>
                                  "bg-gray-200 rounded px-2 text-sm",
                                multiValueLabel: () => "text-gray-900 text-sm",
                                multiValueRemove: () =>
                                  "text-gray-500 hover:text-gray-700",
                                input: () => "text-sm",
                                singleValue: () =>
                                  `${
                                    !isEditing ? "text-gray-600" : "text-black"
                                  }`,
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "31px",
                                  height: "31px",
                                  borderRadius: "8px",
                                  boxShadow: "none",
                                  // border: !isEditing
                                  //   ? "none"
                                  //   : "1px solid #000",
                                  backgroundColor: "#f5f5f5ff",
                                  // "&:hover": {
                                  //   borderColor: !isEditing
                                  //     ? "none"
                                  //     : "#374151",
                                  // },
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                  padding: "0 12px",
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: "0",
                                  padding: "0",
                                  color: !isEditing ? "#6b7280" : "#000000",
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#999a9dff"
                                    : state.isFocused
                                    ? "#cbcccfff"
                                    : "white",
                                  color: state.isSelected
                                    ? "white"
                                    : state.isFocused
                                    ? "#363636ff"
                                    : "#0f0f0fff",
                                  "&:active": {
                                    backgroundColor: state.isSelected
                                      ? "#bcbdc0ff"
                                      : "#9a9fa8ff",
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: "8px",
                                  border: "1px solid #e5e7eb",
                                  boxShadow:
                                    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                  overflow: "hidden",
                                }),
                              }}
                            />
                            {errors.caste && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.caste}
                              </p>
                            )}
                          </div>

                          {/* Sub Caste Field - UPDATED */}
                          {preference["caste"] != "No Caste Barrier" && (
                            <div className="space-y-2">
                              <Label
                                htmlFor="sub-caste"
                                className="text-sm font-semibold text-gray-700"
                              >
                                {t("Sub Caste")}
                              </Label>
                              <Input
                                id="sub-caste"
                                value={preference["sub_caste"] || ""}
                                disabled={!isEditing}
                                onChange={(e) =>
                                  setPreference({
                                    ...preference,
                                    sub_caste: e.target.value,
                                  })
                                }
                                className={`
          h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
          transition-all duration-200 placeholder:text-gray-400 text-black
          ${errors["sub_caste"] ? "border-red-500 ring-2 ring-red-200" : ""}
          ${
            !isEditing
              ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
              : "bg-gray-100 border-black hover:border-gray-700 text-black"
          }
        `}
                              />
                            </div>
                          )}

                          

                          {/* State Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("State")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <Select
                              value={preference["state"] || ""}
                              disabled={!isEditing}
                              onValueChange={(value) => {
                                setPreference({
                                  ...preference,
                                  state: value,
                                });
                                if (value) {
                                  fetchDistricts(value);
                                } else {
                                  setDistricts([]);
                                  setPreference({
                                    ...preference,
                                    district: "",
                                  });
                                }
                              }}
                            >
                              <SelectTrigger
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${errors.state ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              >
                                <SelectValue placeholder={t("Select State")} />
                              </SelectTrigger>
                              <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                                {states.map((state) => (
                                  <SelectItem
                                    key={state.name}
                                    value={state.name}
                                    className="rounded-lg"
                                  >
                                    {state.name}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                            {errors.state && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.state}
                              </p>
                            )}
                          </div>

                          {/* District Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("District")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <ReactSelect
                              value={
                                Array.isArray(preference["district"])
                                  ? preference["district"].map((district) => ({
                                      value: district,
                                      label: district,
                                    }))
                                  : preference["district"]
                                  ? [
                                      {
                                        value: preference["district"],
                                        label: preference["district"],
                                      },
                                    ]
                                  : []
                              }
                              onChange={(selectedOptions) =>
                                setPreference({
                                  ...preference,
                                  district: selectedOptions
                                    ? selectedOptions.map(
                                        (option) => option.value
                                      )
                                    : [],
                                })
                              }
                               options={[{ label: "Any District", value: "Any District" }, ...districts.map((district) => ({
                                value: district,
                                label: district,
                              }))]}
                        
                              placeholder={t("Select District")}
                              isMulti
                              isClearable
                              isDisabled={!isEditing || !preference["state"]}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              classNames={{
                                control: (state) => `
            h-10 rounded-l border transition-all duration-200 text-sm text-black
            ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
            ${errors.district ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing || !preference["state"]
                ? "bg-gray-100 border-none cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700"
            }
          `,
                                option: (state) => `
            text-sm px-3 py-2 cursor-pointer rounded-lg
            ${
              state.isSelected
                ? "bg-red-500 text-white"
                : state.isFocused
                ? "bg-red-50 text-red-700"
                : "text-gray-900"
            }
          `,
                                menu: () =>
                                  "rounded-l border border-gray-200 shadow-lg mt-1",
                                menuList: () => "py-1",
                                placeholder: () => "text-gray-400",
                                multiValue: () =>
                                  "bg-gray-200 rounded px-2 text-sm",
                                multiValueLabel: () => "text-gray-900 text-sm",
                                multiValueRemove: () =>
                                  "text-gray-500 hover:text-gray-700",
                                input: () => "text-sm",
                                singleValue: () =>
                                  `${
                                    !isEditing ? "text-gray-600" : "text-black"
                                  }`,
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "31px",
                                  height: "31px",
                                  borderRadius: "8px",
                                  boxShadow: "none",
                                  // border: !isEditing
                                  //   ? "none"
                                  //   : "1px solid #000",
                                  backgroundColor: "#f5f5f5ff",
                                  // "&:hover": {
                                  //   borderColor: !isEditing
                                  //     ? "none"
                                  //     : "#374151",
                                  // },
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                  padding: "0 12px",
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: "0",
                                  padding: "0",
                                  color: !isEditing ? "#6b7280" : "#000000",
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#999a9dff"
                                    : state.isFocused
                                    ? "#cbcccfff"
                                    : "white",
                                  color: state.isSelected
                                    ? "white"
                                    : state.isFocused
                                    ? "#363636ff"
                                    : "#0f0f0fff",
                                  "&:active": {
                                    backgroundColor: state.isSelected
                                      ? "#bcbdc0ff"
                                      : "#9a9fa8ff",
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: "8px",
                                  border: "1px solid #e5e7eb",
                                  boxShadow:
                                    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                  overflow: "hidden",
                                }),
                              }}
                            />
                            {errors.district && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.district}
                              </p>
                            )}
                          </div>

                          {/* Education Level Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Education level")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <ReactSelect
                              value={
                                preference["education_level"]
                                  ? {
                                      value: preference["education_level"],
                                      label: t(preference["education_level"]),
                                    }
                                  : null
                              }
                              onChange={(selectedOption) =>
                                setPreference({
                                  ...preference,
                                  education_level: selectedOption
                                    ? selectedOption.value
                                    : "",
                                })
                              }
                              options={educationOptions}
                              placeholder={t("Select Education")}
                              isClearable
                              isDisabled={!isEditing}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              classNames={{
                                control: (state) => `
            h-10 rounded-l border transition-all duration-200 text-sm text-black
            ${state.isFocused ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              errors.education_level ? "border-red-500 ring-2 ring-red-200" : ""
            }
            ${
              !isEditing
                ? "bg-gray-100 border-none cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700"
            }
          `,
                                option: (state) => `
            text-sm px-3 py-2 cursor-pointer rounded-lg
            ${
              state.isSelected
                ? "bg-red-500 text-white"
                : state.isFocused
                ? "bg-red-50 text-red-700"
                : "text-gray-900"
            }
          `,
                                menu: () => "rounded-l  shadow-lg mt-1",
                                menuList: () => "py-1",
                                placeholder: () => "text-gray-400",
                                singleValue: () =>
                                  `${
                                    !isEditing ? "text-gray-600" : "text-black"
                                  }`,
                                indicatorSeparator: () => "bg-gray-300",
                                dropdownIndicator: () =>
                                  "text-gray-400 hover:text-gray-600",
                                clearIndicator: () =>
                                  "text-gray-400 hover:text-gray-600",
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "31px",
                                  height: "31px",
                                  borderRadius: "8px",
                                  boxShadow: "none",
                                  // border: !isEditing
                                  //   ? "none"
                                  //   : "1px solid #000",
                                  backgroundColor: "#f5f5f5ff",
                                  // "&:hover": {
                                  //   borderColor: !isEditing
                                  //     ? "none"
                                  //     : "#374151",
                                  // },
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                  padding: "0 12px",
                                }),
                                input: (base) => ({
                                  ...base,
                                  margin: "0",
                                  padding: "0",
                                  color: !isEditing ? "#6b7280" : "#000000",
                                }),
                                indicatorsContainer: (base) => ({
                                  ...base,
                                  height: "31px",
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#999a9dff"
                                    : state.isFocused
                                    ? "#cbcccfff"
                                    : "white",
                                  color: state.isSelected
                                    ? "white"
                                    : state.isFocused
                                    ? "#363636ff"
                                    : "#0f0f0fff",
                                  "&:active": {
                                    backgroundColor: state.isSelected
                                      ? "#bcbdc0ff"
                                      : "#9a9fa8ff",
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: "8px",
                                  border: "1px solid #e5e7eb",
                                  boxShadow:
                                    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                                  overflow: "hidden",
                                }),
                              }}
                            />
                            {errors.education_level && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.education_level}
                              </p>
                            )}
                          </div>

                          {/* Marital Status Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Marital Status")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <Select
                              value={preference["marital_status"] || ""}
                              disabled={!isEditing}
                              onValueChange={(value) =>
                                setPreference({
                                  ...preference,
                                  marital_status: value,
                                })
                              }
                            >
                              <SelectTrigger
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${errors.marital_status ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              >
                                <SelectValue
                                  placeholder={t("Select Marital Status")}
                                />
                              </SelectTrigger>
                              <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                                <SelectItem
                                  value="Single"
                                  className="rounded-lg"
                                >
                                  {t("Single")}
                                </SelectItem>
                                <SelectItem
                                  value="Divorced"
                                  className="rounded-lg"
                                >
                                  {t("Divorced")}
                                </SelectItem>
                                <SelectItem
                                  value="Widowed"
                                  className="rounded-lg"
                                >
                                  {t("Widowed")}
                                </SelectItem>
                              </SelectContent>
                            </Select>
                            {errors.marital_status && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.marital_status}
                              </p>
                            )}
                          </div>

                          {/* Family Status Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Family Status")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <Select
                              value={preference["family_status"] || ""}
                              disabled={!isEditing}
                              onValueChange={(value) =>
                                setPreference({
                                  ...preference,
                                  family_status: value,
                                })
                              }
                            >
                              <SelectTrigger
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${errors.family_status ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              >
                                <SelectValue
                                  placeholder={t("Select Family status")}
                                />
                              </SelectTrigger>
                              <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                                <SelectItem
                                  value="Middle Class"
                                  className="rounded-lg"
                                >
                                  {t("Middle Class")}
                                </SelectItem>
                                <SelectItem
                                  value="Upper Middle Class"
                                  className="rounded-lg"
                                >
                                  {t("Upper Middle Class")}
                                </SelectItem>
                                <SelectItem value="Rich" className="rounded-lg">
                                  {t("Rich")}
                                </SelectItem>
                              </SelectContent>
                            </Select>
                            {errors.family_status && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.family_status}
                              </p>
                            )}
                          </div>

                          {/* Family Type Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Family type")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <Select
                              value={preference["family_type"] || ""}
                              disabled={!isEditing}
                              onValueChange={(value) =>
                                setPreference({
                                  ...preference,
                                  family_type: value,
                                })
                              }
                            >
                              <SelectTrigger
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${errors.family_type ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              >
                                <SelectValue
                                  placeholder={t("Select Family Type")}
                                />
                              </SelectTrigger>
                              <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                                <SelectItem
                                  value="Joint"
                                  className="rounded-lg"
                                >
                                  {t("Joint")}
                                </SelectItem>
                                <SelectItem
                                  value="Nuclear"
                                  className="rounded-lg"
                                >
                                  {t("Nuclear")}
                                </SelectItem>
                              </SelectContent>
                            </Select>
                            {errors.family_type && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.family_type}
                              </p>
                            )}
                          </div>

                          {/* Family Values Field - UPDATED */}
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                              {t("Family Values")}
                              <span className="text-red-500">*</span>
                            </Label>
                            <Select
                              value={preference["family_values"] || ""}
                              disabled={!isEditing}
                              onValueChange={(value) =>
                                setPreference({
                                  ...preference,
                                  family_values: value,
                                })
                              }
                            >
                              <SelectTrigger
                                className={`
            h-10 rounded-l border focus:ring-2 focus:ring-red-500 focus:border-transparent 
            transition-all duration-200 text-black
            ${errors.family_values ? "border-red-500 ring-2 ring-red-200" : ""}
            ${
              !isEditing
                ? "bg-gray-100 border-none text-gray-600 cursor-not-allowed"
                : "bg-gray-100 border-black hover:border-gray-700 text-black"
            }
          `}
                              >
                                <SelectValue
                                  placeholder={t("Select Family Values")}
                                />
                              </SelectTrigger>
                              <SelectContent className="rounded-l border border-gray-200 shadow-lg">
                                <SelectItem
                                  value="Traditional"
                                  className="rounded-lg"
                                >
                                  {t("Traditional")}
                                </SelectItem>
                                <SelectItem
                                  value="Moderate"
                                  className="rounded-lg"
                                >
                                  {t("Moderate")}
                                </SelectItem>
                                <SelectItem
                                  value="Liberal"
                                  className="rounded-lg"
                                >
                                  {t("Liberal")}
                                </SelectItem>
                              </SelectContent>
                            </Select>
                            {errors.family_values && (
                              <p className="text-red-500 text-sm font-medium flex items-center gap-1 mt-1">
                                {errors.family_values}
                              </p>
                            )}
                          </div>
                        </div>
                      </CardContent>
                    </CardContent>
                  </Card>
                </TabsContent>

                <TabsContent
                  value="zodiac"
                  className="space-y-6  cursor-pointer"
                >
                  <Card>
                    <CardHeader>
                      <CardTitle>{t("Zodiac Details")}</CardTitle>
                      <CardDescription>
                        {t("Set your zodiac details for potential matches")}
                      </CardDescription>
                      <div className="mt-2">
                        <CardTitle className="text-sm">{t("Note:")}</CardTitle>
                      </div>
                    </CardHeader>

                    <CardContent className="space-y-8">
                      {/* Top Card: Planet Codes */}
                      <div className="bg-white rounded-xl border border-gray-200 p-6 mb-5 shadow-sm">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">
                          {t(
                            "Enter values in short format (e.g., pu, gu, chan)"
                          )}
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                          {[
                            { tamil: "புதன்", code: "pu" },
                            { tamil: "சந்திரன்", code: "chan" },
                            { tamil: "சுக்ரன்", code: "chk" },
                            { tamil: "சூரியன்", code: "sun" },
                            { tamil: "வியாழன்", code: "viy" },
                            { tamil: "குரு", code: "gu" },
                            { tamil: "செவ்வாய்", code: "sev" },
                            { tamil: "கேது", code: "kee" },
                            { tamil: "லக்னம்", code: "lac" },
                            { tamil: "ராகு", code: "ragu" },
                            { tamil: "சனி", code: "sat" },
                          ].map((planet, index) => (
                            <div
                              key={index}
                              className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-center hover:bg-blue-50 hover:border-blue-300 transition-all duration-200"
                            >
                              <div className="text-xs text-gray-600 mb-1">
                                {planet.tamil}
                              </div>
                              <div className="text-sm font-mono font-bold text-blue-600">
                                {planet.code}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Bottom Card: Zodiac Boxes */}
                      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
                        <h3 className="text-lg font-semibold text-gray-900 mb-6">
                          {t("Zodiac Charts")}
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                          {/* Rasi Box */}
                          <div className="space-y-4">
                            <h3 className="text-center text-lg font-semibold text-blue-600">
                              {t("Rasi")}
                            </h3>
                            <div className="zodiac-4x4-grid">
                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-1"
                                  name="house1"
                                  value={rasibox.house1}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="1"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-2"
                                  name="house2"
                                  value={rasibox.house2}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="2"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-3"
                                  name="house3"
                                  value={rasibox.house3}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="3"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-4"
                                  name="house4"
                                  value={rasibox.house4}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="4"
                                />
                              </div>

                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-12"
                                  name="house12"
                                  value={rasibox.house12}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="12"
                                />
                                <div className="zodiac-empty-cell"></div>
                                <div className="zodiac-empty-cell"></div>
                                <input
                                  type="text"
                                  className="zodiac-box house-5"
                                  name="house5"
                                  value={rasibox.house5}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="5"
                                />
                              </div>

                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-11"
                                  name="house11"
                                  value={rasibox.house11}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="11"
                                />
                                <div className="zodiac-empty-cell">
                                  {/* <span className="zodiac-center-text  font-medium text-blue-600">
                  {t("Rasi")}
                </span> */}
                                </div>
                                <div className="zodiac-empty-cell"></div>
                                <input
                                  type="text"
                                  className="zodiac-box house-6"
                                  name="house6"
                                  value={rasibox.house6}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="6"
                                />
                              </div>

                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-10"
                                  name="house10"
                                  value={rasibox.house10}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="10"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-9"
                                  name="house9"
                                  value={rasibox.house9}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="9"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-8"
                                  name="house8"
                                  value={rasibox.house8}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="8"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-7"
                                  name="house7"
                                  value={rasibox.house7}
                                  onChange={handleRasiChange}
                                  disabled={!isEditing}
                                  placeholder="7"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Navamsa Box */}
                          <div className="space-y-4">
                            <h3 className="text-center text-lg font-semibold text-purple-600">
                              {t("Navamsa")}
                            </h3>
                            <div className="zodiac-4x4-grid">
                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-1"
                                  name="house1"
                                  value={navamsabox.house1}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="1"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-2"
                                  name="house2"
                                  value={navamsabox.house2}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="2"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-3"
                                  name="house3"
                                  value={navamsabox.house3}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="3"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-4"
                                  name="house4"
                                  value={navamsabox.house4}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="4"
                                />
                              </div>

                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-12"
                                  name="house12"
                                  value={navamsabox.house12}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="12"
                                />
                                <div className="zodiac-empty-cell"></div>
                                <div className="zodiac-empty-cell"></div>
                                <input
                                  type="text"
                                  className="zodiac-box house-5"
                                  name="house5"
                                  value={navamsabox.house5}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="5"
                                />
                              </div>

                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-11"
                                  name="house11"
                                  value={navamsabox.house11}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="11"
                                />
                                <div className="zodiac-empty-cell">
                                  {/* <span className="zodiac-center-text text-purple-600 font-medium">
                  {t("Navamsam")}
                </span> */}
                                </div>
                                <div className="zodiac-empty-cell"></div>
                                <input
                                  type="text"
                                  className="zodiac-box house-6"
                                  name="house6"
                                  value={navamsabox.house6}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="6"
                                />
                              </div>

                              <div className="zodiac-grid-row">
                                <input
                                  type="text"
                                  className="zodiac-box house-10"
                                  name="house10"
                                  value={navamsabox.house10}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="10"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-9"
                                  name="house9"
                                  value={navamsabox.house9}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="9"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-8"
                                  name="house8"
                                  value={navamsabox.house8}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="8"
                                />
                                <input
                                  type="text"
                                  className="zodiac-box house-7"
                                  name="house7"
                                  value={navamsabox.house7}
                                  onChange={handleNavamsaChange}
                                  disabled={!isEditing}
                                  placeholder="7"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </TabsContent>
              </Tabs>
              <div className="flex justify-end gap-4 mt-6">
                <Button
                  variant="outline"
                  onClick={() => setIsEditing(false)}
                  className="cursor-pointer"
                  disabled={!isEditing}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  variant="outline"
                  onClick={handleSave}
                  disabled={!isEditing}
                  className="bg-gradient-to-r from-pink-500 to-rose-500 text-white hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                >
                  <Save className="w-4 h-4" />
                  {t("Save Changes")}
                </Button>
              </div>
            </div>
          )}
          {currentPage == 1 && (
            <div className="lg:col-span-3">
              <Profileviews />
            </div>
          )}
          {currentPage == 2 && (
            <div className="lg:col-span-3">
              <InterestReceive />
            </div>
          )}
          {currentPage == 3 && (
            <div className="lg:col-span-3">
              <InterestSend />
            </div>
          )}
          {currentPage == 6 && (
            <div className="lg:col-span-3">
              <Paymenthistory />
            </div>
          )}
        </div>
      </div>

      <AlertDialog open={openConfirm} onOpenChange={setOpenConfirm}>
        <AlertDialogContent className="max-w-sm">
          <AlertDialogHeader>
            <AlertDialogTitle>
              {t("Confirm Account Deletion?")}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {t("This will permanently erase your data and cannot be undone.")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter className="mt-4">
            <AlertDialogCancel
              onClick={() => setOpenConfirm(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>

            <AlertDialogAction
              className=" bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={handleDeleteAccount}
            >
              {t("Confirm")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
